function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRed2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 187.18163 266.90807",
    height: 333,
    width: 234,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title2207"
  }, "Red Card Back") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title2207"
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g4969"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 7.1489577,
    ry: 7.1702428,
    y: 0.3029395,
    x: 0.11524342,
    height: 266.30219,
    width: 186.95114,
    id: "rect4266",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#808080",
      strokeWidth: 0.605879,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "nonzero",
      stroke: "#ff0000",
      strokeWidth: 1.28644881,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    d: "m 177.50319,250.02759 c 0,3.85241 -3.10901,7.01109 -6.92147,7.01109 H 16.590573 c -3.803119,0 -6.9121236,-3.15868 -6.9121236,-7.01109 V 16.881484 c 0,-3.857394 3.1090046,-7.0120851 6.9121236,-7.0120851 H 170.58172 c 3.81246,0 6.92147,3.1546911 6.92147,7.0120851 z",
    id: "path5-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 37.267911,42.899959 c 34.739679,0 69.479849,0 104.219039,0 0.81858,0 8.69242,-0.379759 8.69242,0.30002 0,3.814534 0,7.628571 0,11.443106 0,18.934623 0,37.869248 0,56.803875 0,36.74343 0,73.48735 0,110.23128 0,0.26114 0.17512,1.45325 -0.14364,1.45325 -1.55746,0 -3.11393,0 -4.67039,0 -8.0844,0 -16.16782,0 -24.25122,0 -21.936194,0 -43.8714,0 -65.807098,0 -5.785109,0 -11.570218,0 -17.354835,0 -1.47235,0 -0.684276,-4.14645 -0.684276,-5.33257 0,-16.53797 0,-33.07592 0,-49.61388 0,-39.89562 0,-79.79075 0,-119.686377 0,-1.8664 0,-3.732303 0,-5.598704",
    id: "path7-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 71.54419,107.68874 c 4.504614,0 44.35743,-0.32095 44.35743,0.31696 0,17.10311 0,34.20622 0,51.31033 0,0.51431 -44.35743,0.0618 -44.35743,0.19137 0,-17.00742 0,-34.01484 0,-51.02226 0,-0.26564 0,-0.53127 0,-0.7964",
    id: "path9-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 93.723395,102.97664 c -4.368349,5.10481 -8.737189,10.20913 -13.106028,15.31395 -2.945683,3.44225 -5.891367,6.884 -8.837541,10.32626 -0.683784,0.79889 -4.268487,3.87733 -4.268487,4.9872 0,1.02066 3.297907,3.8534 3.925611,4.58701 3.060303,3.57631 6.120606,7.15063 9.180417,10.72695 4.368839,5.10432 8.737679,10.20863 13.106028,15.31395 4.368347,-5.10532 8.736695,-10.20963 13.106025,-15.31395 2.94568,-3.44276 5.89137,-6.88451 8.83705,-10.32626 0.68378,-0.79938 4.26897,-3.87733 4.26897,-4.9877 0,-1.02067 -3.29789,-3.85291 -3.9256,-4.58651 -3.05981,-3.57582 -6.12061,-7.15114 -9.18042,-10.72695 -4.36933,-5.10482 -8.737678,-10.20914 -13.106025,-15.31395",
    id: "path11-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 73.560616,110.04454 c 8.347579,0 16.695156,0 25.042735,0 4.490349,0 8.980689,0 13.472029,0 2.32289,0 1.8103,0.20035 1.8103,2.56063 0,10.35167 0,20.70284 0,31.05502 0,4.05275 0,8.10551 0,12.15827 0,2.14199 -1.22687,1.3456 -3.25167,1.3456 -8.80359,0 -17.606698,0 -26.409804,0 -3.227068,0 -6.454628,0 -9.681696,0 -1.588937,0 -0.981894,-1.0416 -0.981894,-2.56063 0,-14.85346 0,-29.70593 0,-44.55889",
    id: "path13-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 93.723395,105.33294 c -3.95611,4.62239 -7.911728,9.24479 -11.867837,13.86718 -2.820241,3.29523 -5.640482,6.59046 -8.460723,9.88569 -0.618848,0.72364 -3.86707,3.51303 -3.86707,4.51824 0,0.917 2.961917,3.46069 3.52567,4.11954 2.780886,3.24938 5.561773,6.49876 8.342659,9.74815 4.1091,4.8013 8.2182,9.60261 12.327301,14.40392 3.956108,-4.6229 7.912215,-9.24479 11.867345,-13.86669 2.82073,-3.29522 5.64146,-6.59046 8.46121,-9.88568 0.61885,-0.72365 3.86658,-3.51353 3.86658,-4.51924 0,-0.91651 -2.96142,-3.46069 -3.52517,-4.11904 -2.78138,-3.24938 -5.56178,-6.49876 -8.34217,-9.74814 -4.1096,-4.80132 -8.219187,-9.60262 -12.327795,-14.40393",
    id: "path15-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 77.592975,114.75664 c 8.756373,0 17.512746,0 26.269115,0 1.09307,0 5.99074,-0.74806 5.99074,0.60403 0,3.99693 0,7.99337 0,11.98982 0,1.75825 0.0216,25.10197 -0.0197,25.10197 -8.93346,0 -17.865948,0 -26.799417,0 -1.066506,0 -5.440757,0.73759 -5.440757,-0.60502 0,-3.99595 0,-7.99289 0,-11.98982 0,-8.36666 0,-16.73382 0,-25.10098",
    id: "path17-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 93.723395,110.04454 c -3.360381,3.92667 -6.720763,7.85334 -10.081144,11.78001 -2.252552,2.63189 -4.505105,5.26379 -6.757656,7.8957 -0.53227,0.62196 -3.323979,3.01962 -3.323979,3.8838 0,0.77547 2.50393,2.92644 2.980119,3.48262 2.367171,2.76596 4.734344,5.53192 7.101516,8.29689 3.360381,3.92716 6.720762,7.85433 10.081144,11.7805 3.360872,-3.92617 6.720765,-7.85334 10.080655,-11.7805 2.25304,-2.63141 4.50608,-5.2628 6.75716,-7.8952 0.53325,-0.62197 3.32447,-3.02014 3.32447,-3.88431 0,-0.77447 -2.50393,-2.92544 -2.98012,-3.48212 -2.36717,-2.76596 -4.73434,-5.53142 -7.10151,-8.29738 -3.35989,-3.92667 -6.719783,-7.85334 -10.080655,-11.78001",
    id: "path19-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 79.6094,117.11245 c 8.601415,0 17.203321,0 25.80424,0 3.10606,0 2.42326,0.27859 2.42326,3.43029 0,5.2922 0,10.5844 0,15.87611 0,4.33085 0,8.66169 0,12.99155 0,1.52302 -5.27842,0.68576 -6.51022,0.68576 -5.453547,0 -10.908079,0 -16.362118,0 -1.90279,0 -5.355162,1.12531 -5.355162,-1.19411 0,-10.59636 0,-21.19274 0,-31.7896",
    id: "path21-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 93.723395,112.40034 c -2.947159,3.44425 -5.89481,6.88849 -8.842462,10.33273 -2.127109,2.48538 -4.254219,4.97126 -6.381822,7.45664 -0.467334,0.54621 -2.922069,2.65482 -2.922069,3.41434 0,0.67081 2.168432,2.53372 2.580178,3.01514 2.087756,2.43903 4.175019,4.87807 6.262282,7.3171 3.101626,3.62415 6.202759,7.24831 9.303893,10.87147 2.94765,-3.44375 5.895301,-6.88849 8.842955,-10.33224 2.12711,-2.48488 4.25422,-4.97076 6.38133,-7.45662 0.46733,-0.54622 2.92207,-2.65533 2.92207,-3.41485 0,-0.66981 -2.16843,-2.53372 -2.57969,-3.01465 -2.08775,-2.43953 -4.17551,-4.87856 -6.26327,-7.31758 -3.101129,-3.62367 -6.202262,-7.24732 -9.303395,-10.87148",
    id: "path23-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 93.723395,114.75664 c -2.612155,3.05252 -5.224308,6.10505 -7.836954,9.15708 -1.836871,2.14698 -3.674234,4.29346 -5.511596,6.43995 -0.445198,0.5203 -2.78187,2.52774 -2.78187,3.25038 0,0.63293 2.046434,2.39119 2.435551,2.8457 1.800467,2.10412 3.600935,4.20725 5.401403,6.31237 2.764652,3.22945 5.529304,6.45989 8.293466,9.69034 2.612153,-3.05303 5.224308,-6.10506 7.837445,-9.15808 1.83589,-2.14599 3.67374,-4.29297 5.51061,-6.43895 0.44569,-0.5213 2.78138,-2.52774 2.78138,-3.25138 0,-0.63194 -2.04643,-2.39118 -2.43407,-2.84521 -1.80047,-2.10412 -3.60192,-4.20774 -5.40239,-6.31187 -2.763671,-3.22994 -5.528324,-6.45989 -8.292975,-9.69033",
    id: "path25-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 81.625334,119.46824 c 8.030282,0 16.061056,0 24.091336,0 0.21055,0 0.10429,23.12543 0.10429,25.33122 0,0.44654 0.31484,2.59153 0,2.94039 -0.35222,0.38973 -3.28413,0 -3.78,0 -5.36598,0 -10.732455,0 -16.098439,0 -1.403971,0 -2.808435,0 -4.212406,0 -0.235635,0 -0.104781,-2.24067 -0.104781,-2.50182 0,-5.27277 0,-10.54554 0,-15.81781 0,-3.31716 0,-6.63482 0,-9.95198",
    id: "path27-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 93.723395,119.46824 c -2.016426,2.35631 -4.03236,4.7121 -6.048785,7.06791 -1.386262,1.6197 -2.772524,3.23942 -4.158785,4.85962 -0.30057,0.35135 -1.890491,1.71888 -1.890491,2.20828 0,0.4904 1.589921,1.85792 1.890491,2.20878 1.386261,1.61971 2.772523,3.23941 4.158785,4.85913 2.016425,2.35629 4.032359,4.7116 6.048785,7.06789 2.016917,-2.35629 4.031866,-4.7116 6.048784,-7.06789 1.386261,-1.61972 2.772521,-3.23942 4.157801,-4.85913 0.30106,-0.35086 1.89098,-1.71838 1.89098,-2.20878 0,-0.4894 -1.58992,-1.85693 -1.89098,-2.20828 -1.38528,-1.6202 -2.77154,-3.23992 -4.157801,-4.85962 -2.016918,-2.35581 -4.031867,-4.7116 -6.048784,-7.06791",
    id: "path29-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 123.96732,105.33294 c -1.34396,0 -2.68791,0 -4.03188,0 1.34397,1.57036 2.68792,3.14123 4.03188,4.7116 0,-1.57037 0,-3.14124 0,-4.7116",
    id: "path31-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 123.96732,112.40034 c -1.34396,-1.57037 -2.68791,-3.14123 -4.03188,-4.7116 0,1.52651 0,3.05302 0,4.58003 0,0.2766 3.51239,0.13157 4.03188,0.13157",
    id: "path33-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 63.479474,105.33294 c 1.343955,0 2.68791,0 4.031866,0 -1.343956,1.57036 -2.687911,3.14123 -4.031866,4.7116 0,-1.57037 0,-3.14124 0,-4.7116",
    id: "path35-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 63.479474,112.40034 c 1.343955,-1.57037 2.68791,-3.14123 4.031866,-4.7116 0,1.52651 0,3.05302 0,4.58003 0,0.2766 -3.511896,0.13157 -4.031866,0.13157",
    id: "path37-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 67.51134,154.80776 c -1.343956,0 -2.687911,0 -4.031867,0 1.343956,1.57087 2.687911,3.14173 4.031867,4.7116 0,-1.56987 0,-3.14073 0,-4.7116",
    id: "path39-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 67.51134,161.87566 c -1.343956,-1.57086 -2.687911,-3.14173 -4.031867,-4.7116 0,1.52601 0,3.05302 0,4.58003 0,0.2771 3.512388,0.13157 4.031867,0.13157",
    id: "path41-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 119.93544,154.80776 c 1.34397,0 2.68792,0 4.03188,0 -1.34396,1.57087 -2.68791,3.14173 -4.03188,4.7116 0,-1.56987 0,-3.14073 0,-4.7116",
    id: "path43-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 119.93544,161.87566 c 1.34397,-1.57086 2.68792,-3.14173 4.03188,-4.7116 0,1.52601 0,3.05302 0,4.58003 0,0.2771 -3.51239,0.13157 -4.03188,0.13157",
    id: "path45-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 67.51134,138.31665 c -1.343956,0 -2.687911,0 -4.031867,0 1.343956,1.57086 2.687911,3.14074 4.031867,4.7116 0,-1.57086 0,-3.14074 0,-4.7116",
    id: "path47-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 67.51134,145.38356 c -1.343956,-1.56988 -2.687911,-3.14074 -4.031867,-4.7116 0,1.527 0,3.05302 0,4.58002 0,0.2771 3.512388,0.13158 4.031867,0.13158",
    id: "path49-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 63.479474,121.82455 c 1.343955,0 2.68791,0 4.031866,0 -1.343956,1.57036 -2.687911,3.14123 -4.031866,4.7116 0,-1.57037 0,-3.14124 0,-4.7116",
    id: "path51-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 63.479474,128.89245 c 1.343955,-1.57087 2.68791,-3.14124 4.031866,-4.71211 0,1.52652 0,3.05353 0,4.58004 0,0.27659 -3.511896,0.13207 -4.031866,0.13207",
    id: "path53-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 123.96732,121.82455 c -1.34396,0 -2.68791,0 -4.03188,0 1.34397,1.57036 2.68792,3.14123 4.03188,4.7116 0,-1.57037 0,-3.14124 0,-4.7116",
    id: "path55-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 123.96732,128.89245 c -1.34396,-1.57087 -2.68791,-3.14124 -4.03188,-4.71211 0,1.52652 0,3.05353 0,4.58004 0,0.27659 3.51239,0.13207 4.03188,0.13207",
    id: "path57-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 119.93544,138.31665 c 1.34397,0 2.68792,0 4.03188,0 -1.34396,1.57086 -2.68791,3.14074 -4.03188,4.7116 0,-1.57086 0,-3.14074 0,-4.7116",
    id: "path59-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 119.93544,145.38356 c 1.34397,-1.56988 2.68792,-3.14074 4.03188,-4.7116 0,1.527 0,3.05302 0,4.58002 0,0.2771 -3.51239,0.13158 -4.03188,0.13158",
    id: "path61-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 79.659577,34.948444 c -0.823984,-2.066248 -1.695686,-4.170871 -2.260914,-6.329815 -0.509641,-1.945642 -0.915484,-6.69562 1.639606,-7.629568 2.451292,-0.895075 3.342179,3.398395 3.310203,5.085382 -0.04821,2.534218 -1.237206,5.123257 -2.132521,7.452646 -0.182014,0.474449 -0.367964,0.950394 -0.556374,1.421355",
    id: "path63-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 79.646787,34.995291 c -2.026264,-0.864176 -4.28226,-1.710909 -6.07584,-3.023122 -1.591889,-1.165191 -4.127302,-4.618407 -2.648065,-6.730505 1.493011,-2.132032 4.60841,0.311482 5.614901,1.751776 1.443818,2.064752 2.122191,4.889023 2.880256,7.271736 0.07723,0.242707 0.15299,0.488404 0.228748,0.730114",
    id: "path65-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 79.653182,34.995291 c 2.026264,-0.864674 4.281768,-1.710909 6.075841,-3.023122 1.591888,-1.164693 4.126809,-4.618905 2.648065,-6.730505 -1.493012,-2.132531 -4.608903,0.311482 -5.615393,1.751776 -1.471858,2.105619 -2.161054,5.000658 -2.930926,7.43271 -0.05952,0.188883 -0.119047,0.381255 -0.177587,0.569141",
    id: "path67-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 74.461342,35.278365 c -1.639606,-0.492889 -3.670297,-0.329921 -4.71811,1.20905 -0.558343,0.820319 -0.685261,3.998931 1.092086,3.380952 0.309916,-0.107649 0.563261,-1.501095 0.941064,-1.822047 0.720188,-0.612 2.069062,-0.593061 2.943716,-0.66383 1.176699,-0.0942 2.398655,0.0329 3.555186,-0.129078 0.0015,-0.0069 0.0034,-0.01345 0.0069,-0.01993 -1.096023,-0.86019 -2.493108,-1.538971 -3.820829,-1.955112",
    id: "path69-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 84.757951,35.278365 c 1.639606,-0.493387 3.670297,-0.329921 4.717619,1.20905 0.558341,0.820319 0.685751,3.99943 -1.092087,3.380952 -0.309916,-0.107649 -0.562769,-1.500597 -0.940572,-1.822047 -0.719695,-0.612 -2.069063,-0.593061 -2.943716,-0.66383 -1.177191,-0.0942 -2.398655,0.0329 -3.555678,-0.129078 -0.0015,-0.0069 -0.0034,-0.01345 -0.0069,-0.01993 1.096515,-0.86019 2.493108,-1.538971 3.821321,-1.955112",
    id: "path71-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 78.265445,39.856405 c 0.23957,2.075717 3.792296,1.066515 2.093167,-1.790149 -1.193426,-2.00744 -1.87721,-0.129079 -2.093167,1.790149",
    id: "path73-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 107.88707,34.948444 c -0.82447,-2.06575 -1.69617,-4.171369 -2.26091,-6.329815 -0.50964,-1.945642 -0.91499,-6.695121 1.63911,-7.629568 2.45179,-0.896071 3.34316,3.398893 3.3107,5.085382 -0.0483,2.534717 -1.23672,5.123257 -2.13203,7.452646 -0.183,0.474449 -0.36797,0.949895 -0.55687,1.421355",
    id: "path75-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 107.87428,34.995291 c -2.02577,-0.864176 -4.28275,-1.710909 -6.07535,-3.023122 -1.59188,-1.165191 -4.127297,-4.618905 -2.648552,-6.730505 1.493502,-2.131534 4.608412,0.310984 5.615882,1.751776 1.44333,2.064752 2.12121,4.889521 2.87878,7.271736 0.0777,0.242707 0.15349,0.488404 0.22924,0.730114",
    id: "path77-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 107.88117,34.995291 c 2.02577,-0.864674 4.28177,-1.710909 6.07534,-3.023122 1.59288,-1.165191 4.12731,-4.618407 2.64758,-6.730505 -1.49252,-2.132032 -4.6084,0.311482 -5.6149,1.751776 -1.47284,2.105619 -2.15958,5.000658 -2.92994,7.43271 -0.06,0.189381 -0.11905,0.380756 -0.17808,0.569141",
    id: "path79-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 102.68835,35.278365 c -1.63912,-0.493387 -3.66981,-0.329423 -4.716639,1.20905 -0.558834,0.820818 -0.686736,3.99943 1.092087,3.380952 0.308933,-0.107649 0.562769,-1.501095 0.940572,-1.822047 0.7192,-0.612 2.06906,-0.593061 2.94372,-0.66383 1.1767,-0.0942 2.39865,0.0329 3.55469,-0.129078 9.8e-4,-0.0069 0.004,-0.01345 0.007,-0.01993 -1.09701,-0.86019 -2.49212,-1.538971 -3.82132,-1.955112",
    id: "path81-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 112.98545,35.278365 c 1.63911,-0.493387 3.67078,-0.329423 4.7186,1.20905 0.55785,0.820319 0.68477,3.998931 -1.09208,3.380952 -0.31091,-0.107649 -0.56376,-1.501095 -0.94156,-1.822047 -0.71921,-0.612 -2.06906,-0.593061 -2.94372,-0.66383 -1.1767,-0.09469 -2.39866,0.0329 -3.55568,-0.129078 -9.8e-4,-0.0069 -0.003,-0.01345 -0.007,-0.01993 1.09702,-0.859691 2.49312,-1.538971 3.82133,-1.955112",
    id: "path83-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 106.49294,39.856405 c 0.24006,2.075717 3.79279,1.066515 2.09366,-1.790149 -1.19343,-2.00794 -1.87819,-0.128581 -2.09366,1.790149",
    id: "path85-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 136.11507,34.948444 c -0.8235,-2.066746 -1.69619,-4.170871 -2.26191,-6.329815 -0.50865,-1.945642 -0.91499,-6.69562 1.64108,-7.629568 2.4508,-0.895573 3.3412,3.398893 3.30972,5.085382 -0.0492,2.534717 -1.2377,5.122759 -2.13302,7.452646 -0.18102,0.474449 -0.36796,0.950394 -0.55587,1.421355",
    id: "path87-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 136.10227,34.995291 c -2.02676,-0.864674 -4.28177,-1.710909 -6.07633,-3.023122 -1.59189,-1.165191 -4.12632,-4.618905 -2.64757,-6.730505 1.49252,-2.132032 4.60841,0.311482 5.61489,1.751776 1.47186,2.105619 2.16056,5.00016 2.92995,7.43271 0.0609,0.189381 0.12003,0.380756 0.17906,0.569141",
    id: "path89-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 136.10817,34.995291 c 2.02676,-0.864176 4.28276,-1.710909 6.07634,-3.023122 1.59189,-1.165191 4.12631,-4.618905 2.64856,-6.730505 -1.49351,-2.132032 -4.6094,0.311482 -5.61589,1.751776 -1.47186,2.105619 -2.16056,5.000658 -2.92995,7.43271 -0.06,0.188883 -0.12003,0.381255 -0.17906,0.569141",
    id: "path91-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 130.91732,35.278365 c -1.6401,-0.493387 -3.67079,-0.329423 -4.71861,1.20905 -0.55883,0.820818 -0.68574,3.998931 1.0921,3.380952 0.30991,-0.107649 0.56276,-1.501095 0.94056,-1.822047 0.72019,-0.612 2.07005,-0.593061 2.94371,-0.66383 1.17769,-0.0942 2.39866,0.0329 3.55569,-0.129078 0.002,-0.0069 0.004,-0.01345 0.007,-0.01993 -1.09701,-0.86019 -2.49213,-1.538971 -3.82034,-1.955112",
    id: "path93-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 141.21246,35.278365 c 1.64107,-0.492889 3.67177,-0.329921 4.71859,1.20905 0.55884,0.820319 0.68674,3.998433 -1.09209,3.380952 -0.30893,-0.107649 -0.56276,-1.500597 -0.94057,-1.822047 -0.72018,-0.612 -2.06906,-0.593061 -2.94371,-0.66383 -1.1767,-0.0942 -2.39865,0.0329 -3.55568,-0.129078 -0.002,-0.0069 -0.004,-0.01345 -0.006,-0.01993 1.09602,-0.86019 2.49212,-1.538971 3.81935,-1.955112",
    id: "path95-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 134.72093,39.856405 c 0.24006,2.076714 3.79181,1.065518 2.09366,-1.790149 -1.19442,-2.00794 -1.87721,-0.128581 -2.09366,1.790149",
    id: "path97-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 51.432082,34.948444 c -0.824477,-2.06575 -1.696179,-4.171369 -2.261407,-6.329815 -0.509641,-1.945642 -0.914992,-6.69562 1.639606,-7.629568 2.451784,-0.896071 3.342179,3.398893 3.310204,5.085382 -0.04821,2.534717 -1.237207,5.122759 -2.132522,7.452646 -0.182014,0.474449 -0.367964,0.949895 -0.555881,1.421355",
    id: "path99-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 51.418799,34.995291 c -2.026756,-0.864674 -4.281768,-1.710909 -6.07584,-3.023122 -1.591889,-1.165191 -4.12681,-4.618407 -2.648065,-6.730505 1.493011,-2.132032 4.608902,0.311482 5.615393,1.751776 1.443326,2.064752 2.12219,4.889521 2.879764,7.271736 0.07723,0.242707 0.152991,0.488404 0.228748,0.730114",
    id: "path101-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 51.425195,34.995291 c 2.026263,-0.864176 4.282259,-1.710909 6.07584,-3.023122 1.591889,-1.165191 4.127301,-4.618407 2.648064,-6.730505 -1.493502,-2.132032 -4.608409,0.311482 -5.615392,1.751776 -1.443326,2.064752 -2.121699,4.889521 -2.879764,7.271736 -0.07723,0.242707 -0.152991,0.487906 -0.228748,0.730114",
    id: "path103-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 46.233354,35.278365 c -1.639606,-0.493387 -3.670297,-0.329423 -4.717619,1.20905 -0.558341,0.820319 -0.685752,3.99943 1.092088,3.380952 0.309424,-0.107649 0.562768,-1.501095 0.940571,-1.822047 0.719696,-0.612 2.069062,-0.593061 2.943716,-0.66383 1.177191,-0.0942 2.399148,0.0329 3.555677,-0.129078 9.85e-4,-0.0069 0.0034,-0.01345 0.0069,-0.01993 -1.096514,-0.859691 -2.493106,-1.539469 -3.821321,-1.955112",
    id: "path105-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 56.529471,35.278365 c 1.640099,-0.492889 3.67079,-0.329921 4.718603,1.20905 0.558342,0.820319 0.685752,3.998931 -1.092087,3.380952 -0.309917,-0.107649 -0.563262,-1.501095 -0.941065,-1.822047 -0.719694,-0.612 -2.069061,-0.593061 -2.943715,-0.66383 -1.176698,-0.0942 -2.398655,0.0329 -3.555185,-0.129078 -0.0015,-0.0069 -0.0039,-0.01345 -0.0069,-0.01993 1.096514,-0.86019 2.492615,-1.538473 3.820336,-1.955112",
    id: "path107-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 50.037457,39.856405 c 0.240063,2.075717 3.792296,1.066515 2.093658,-1.790149 -1.193424,-2.00744 -1.8777,-0.128581 -2.093658,1.790149",
    id: "path109-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 79.407709,231.08251 c -0.823985,2.06624 -1.696179,4.17136 -2.261408,6.32931 -0.509148,1.94464 -0.915483,6.69711 1.640099,7.63006 2.451785,0.89508 3.341687,-3.39889 3.309712,-5.08538 -0.04821,-2.53571 -1.237698,-5.12325 -2.132029,-7.45264 -0.182507,-0.47445 -0.367965,-0.9499 -0.556374,-1.42135",
    id: "path111-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 79.394426,231.03566 c -2.026755,0.86318 -4.281768,1.71041 -6.075348,3.02312 -1.59238,1.16519 -4.127302,4.6179 -2.648557,6.73 1.493503,2.13204 4.608902,-0.31098 5.615393,-1.75127 1.443818,-2.06526 2.121699,-4.89003 2.879765,-7.27224 0.07723,-0.2422 0.15299,-0.48841 0.228747,-0.72961",
    id: "path113-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 79.401313,231.03566 c 2.026756,0.86318 4.281768,1.71041 6.075349,3.02312 1.592381,1.16519 4.126809,4.6179 2.648065,6.73 -1.493011,2.13204 -4.60841,-0.31098 -5.615393,-1.75127 -1.471858,-2.10612 -2.160561,-5.00066 -2.929942,-7.43272 -0.06001,-0.18937 -0.119047,-0.38075 -0.178079,-0.56913",
    id: "path115-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 74.208981,230.75258 c -1.639606,0.49239 -3.670298,0.32893 -4.717618,-1.21004 -0.558343,-0.81933 -0.685752,-3.99893 1.092086,-3.38095 0.309425,0.10764 0.563261,1.50109 0.940573,1.82204 0.720187,0.612 2.069062,0.59405 2.944207,0.66383 1.176699,0.0947 2.39964,-0.0318 3.555186,0.12958 9.83e-4,0.008 0.0034,0.014 0.0069,0.0199 -1.096023,0.86019 -2.493107,1.53897 -3.821321,1.95561",
    id: "path117-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 84.505591,230.75258 c 1.639605,0.49239 3.670788,0.32893 4.71811,-1.21004 0.558341,-0.81933 0.685752,-3.99794 -1.092087,-3.38095 -0.309424,0.10764 -0.563261,1.50109 -0.941064,1.82204 -0.720187,0.612 -2.06857,0.59405 -2.943715,0.66383 -1.1767,0.0947 -2.39964,-0.0318 -3.555186,0.12958 -0.0015,0.007 -0.0039,0.014 -0.0069,0.0199 1.095531,0.86019 2.493107,1.53897 3.820829,1.95561",
    id: "path119-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 78.013084,226.17454 c 0.239571,-2.07622 3.792297,-1.06751 2.093659,1.78915 -1.193425,2.00844 -1.876225,0.13058 -2.093659,-1.78915",
    id: "path121-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 107.6352,231.08251 c -0.82447,2.06624 -1.69617,4.17136 -2.26091,6.32931 -0.50964,1.94464 -0.91499,6.69611 1.63911,7.63006 2.45179,0.89508 3.34316,-3.39889 3.3107,-5.08538 -0.0482,-2.53372 -1.23671,-5.12524 -2.13203,-7.45264 -0.183,-0.47445 -0.36796,-0.9499 -0.55687,-1.42135",
    id: "path123-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 107.62241,231.03566 c -2.02675,0.86318 -4.28275,1.71041 -6.07534,3.02312 -1.591893,1.16519 -4.127306,4.6179 -2.64856,6.73 1.4935,2.13204 4.60841,-0.31098 5.61588,-1.75127 1.47186,-2.10612 2.15958,-5.00066 2.92994,-7.43272 0.059,-0.18838 0.11905,-0.38175 0.17808,-0.56913",
    id: "path125-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 107.6293,231.03566 c 2.02676,0.86318 4.28177,1.71041 6.07535,3.02312 1.59287,1.16519 4.1273,4.6179 2.64757,6.73 -1.4935,2.13204 -4.6084,-0.31098 -5.6149,-1.75127 -1.47186,-2.10612 -2.16056,-5.00066 -2.93092,-7.43272 -0.059,-0.18838 -0.11807,-0.38175 -0.1771,-0.56913",
    id: "path127-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 102.43648,230.75258 c -1.63912,0.49239 -3.669809,0.32893 -4.717622,-1.21004 -0.55785,-0.81933 -0.685752,-3.99893 1.092087,-3.38095 0.309917,0.10764 0.563754,1.50109 0.941557,1.82204 0.720188,0.612 2.068078,0.59405 2.943718,0.66383 1.17571,0.0947 2.39964,-0.0318 3.55469,0.12958 9.8e-4,0.007 0.004,0.014 0.007,0.0199 -1.09602,0.86019 -2.4931,1.53897 -3.82132,1.95561",
    id: "path129-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 112.73358,230.75258 c 1.63911,0.49239 3.66981,0.32893 4.7186,-1.21004 0.55687,-0.81933 0.68477,-3.99794 -1.09208,-3.38095 -0.31091,0.10764 -0.56376,1.50109 -0.94156,1.82204 -0.72019,0.612 -2.06906,0.59405 -2.94471,0.66383 -1.17571,0.0947 -2.39865,-0.0318 -3.55469,0.12958 -9.8e-4,0.008 -0.003,0.014 -0.007,0.0199 1.09602,0.86019 2.49312,1.53897 3.82133,1.95561",
    id: "path131-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 106.24009,226.17454 c 0.24104,-2.07622 3.79279,-1.06751 2.09464,1.78915 -1.19342,2.00844 -1.87622,0.13058 -2.09464,-1.78915",
    id: "path133-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 135.8632,231.08251 c -0.82448,2.06624 -1.69619,4.17136 -2.2619,6.32931 -0.50866,1.94464 -0.915,6.69711 1.64107,7.63006 2.45179,0.89508 3.3412,-3.39889 3.30972,-5.08538 -0.0483,-2.53372 -1.23573,-5.12524 -2.13302,-7.45264 -0.18201,-0.47445 -0.36796,-0.9499 -0.55587,-1.42135",
    id: "path135-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 135.8504,231.03566 c -2.02675,0.86318 -4.28275,1.71041 -6.07633,3.02312 -1.59189,1.16519 -4.12631,4.6179 -2.64856,6.73 1.49351,2.13204 4.6094,-0.31098 5.61589,-1.75127 1.44431,-2.06526 2.12219,-4.89003 2.88075,-7.27224 0.0768,-0.2422 0.15151,-0.48841 0.22825,-0.72961",
    id: "path137-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 135.85631,231.03566 c 2.02675,0.86318 4.28275,1.71041 6.07633,3.02312 1.59189,1.16519 4.12631,4.6179 2.64757,6.73 -1.49252,2.13204 -4.60841,-0.31098 -5.6149,-1.75127 -1.44431,-2.06526 -2.12121,-4.89003 -2.88075,-7.27224 -0.0768,-0.2422 -0.1525,-0.48841 -0.22825,-0.72961",
    id: "path139-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 130.66447,230.75258 c -1.6401,0.49239 -3.6708,0.32893 -4.71763,-1.21004 -0.55883,-0.81933 -0.68673,-3.99794 1.0921,-3.38095 0.30893,0.10764 0.56276,1.50109 0.94057,1.82204 0.72018,0.612 2.06906,0.59405 2.94371,0.66383 1.1767,0.0947 2.40063,-0.0318 3.55568,0.12958 9.8e-4,0.008 0.004,0.014 0.007,0.0199 -1.09701,0.86019 -2.49213,1.53897 -3.82132,1.95561",
    id: "path141-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 140.96059,230.75258 c 1.64009,0.49239 3.67177,0.32893 4.7186,-1.21004 0.55883,-0.81933 0.68574,-3.99794 -1.0921,-3.38095 -0.30893,0.10764 -0.56276,1.50109 -0.94057,1.82204 -0.72018,0.612 -2.06807,0.59405 -2.94371,0.66383 -1.1767,0.0947 -2.39964,-0.0318 -3.55568,0.12958 -0.002,0.008 -0.004,0.014 -0.007,0.0199 1.09505,0.86019 2.49311,1.53897 3.82035,1.95561",
    id: "path143-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 134.46906,226.17454 c 0.23908,-2.07622 3.79181,-1.06751 2.09366,1.78915 -1.19441,2.00844 -1.87721,0.13058 -2.09366,-1.78915",
    id: "path145-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 51.180213,231.08251 c -0.824969,2.06524 -1.69667,4.17136 -2.2619,6.32931 -0.509148,1.94464 -0.914991,6.69711 1.640099,7.63006 2.451293,0.89508 3.342671,-3.39889 3.310204,-5.08538 -0.04821,-2.53571 -1.237699,-5.12325 -2.132522,-7.45264 -0.182014,-0.47445 -0.367964,-0.9499 -0.555881,-1.42135",
    id: "path147-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 51.166931,231.03566 c -2.027248,0.86318 -4.28226,1.71041 -6.075841,3.02312 -1.592381,1.16519 -4.126809,4.6179 -2.648557,6.73 1.493503,2.13204 4.608902,-0.31197 5.615886,-1.75127 1.443325,-2.06526 2.121206,-4.89003 2.879763,-7.27224 0.07723,-0.24121 0.152992,-0.48841 0.228749,-0.72961",
    id: "path149-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 51.173326,231.03566 c 2.026755,0.86318 4.281768,1.7114 6.075348,3.02312 1.592382,1.1642 4.127302,4.6179 2.648557,6.73 -1.493503,2.13204 -4.60841,-0.31098 -5.615393,-1.75127 -1.471858,-2.10612 -2.160561,-5.00066 -2.930434,-7.43272 -0.06001,-0.18838 -0.119047,-0.38175 -0.178078,-0.56913",
    id: "path151-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 45.981485,230.75258 c -1.640097,0.49239 -3.670789,0.32893 -4.71811,-1.21004 -0.558342,-0.81933 -0.685752,-3.99893 1.092086,-3.38095 0.309425,0.10764 0.563754,1.50109 0.941064,1.82204 0.720188,0.612 2.068571,0.59405 2.943716,0.66383 1.176699,0.0947 2.39964,-0.0318 3.555186,0.12958 0.0015,0.008 0.0039,0.014 0.0069,0.0199 -1.096023,0.86019 -2.492615,1.53897 -3.820829,1.95561",
    id: "path153-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 56.277602,230.75258 c 1.640099,0.49239 3.67079,0.32993 4.718603,-1.21004 0.55785,-0.81933 0.685261,-3.99893 -1.092579,-3.38095 -0.309425,0.10764 -0.563261,1.50109 -0.940572,1.82204 -0.720187,0.612 -2.06857,0.59405 -2.943716,0.66383 -1.176698,0.0947 -2.399639,-0.0318 -3.555677,0.12958 -9.84e-4,0.008 -0.0034,0.014 -0.0069,0.0199 1.096021,0.86019 2.493106,1.53897 3.820828,1.95561",
    id: "path155-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 49.785096,226.17454 c 0.240554,-2.07622 3.791805,-1.06751 2.094151,1.78915 -1.193917,2.00944 -1.875733,0.13058 -2.094151,-1.78915",
    id: "path157-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 157.04771,232.48492 c 1.9205,1.0416 3.99743,2.3244 6.12258,2.88058 1.93427,0.50635 5.5962,0.018 5.94842,-2.57159 0.34042,-2.49883 -3.14933,-3.62117 -5.03147,-3.39989 -2.34749,0.2761 -4.80911,1.87687 -6.86539,2.99222 -0.057,0.0309 -0.11707,0.0668 -0.17414,0.0987",
    id: "path159-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 157.01131,232.49987 c 0.82644,2.65233 3.39039,12.77924 8.00667,10.38606 2.2491,-1.16519 0.43979,-5.02259 -0.7379,-6.3343 -1.66174,-1.84796 -4.41754,-2.81879 -6.645,-3.78364 -0.20661,-0.0907 -0.41716,-0.17941 -0.62377,-0.26812",
    id: "path161-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 157.00737,232.49189 c 0.82842,-2.65432 3.39236,-12.78521 8.01061,-10.38606 2.24714,1.1672 0.44077,5.01263 -0.7379,6.32634 -1.66272,1.84995 -4.41852,2.82476 -6.64697,3.79359 -0.20858,0.0897 -0.41912,0.17743 -0.62574,0.26613",
    id: "path163-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 156.76535,238.55907 c 0.37386,1.70643 0.45159,4.26606 -1.03503,5.51199 -0.96714,0.81134 -3.4691,0.54422 -2.89354,-1.27583 0.10725,-0.3369 1.27016,-0.68975 1.55942,-1.1024 0.59819,-0.85521 0.51162,-2.45199 0.56769,-3.43676 0.0778,-1.37551 -0.0462,-2.79388 0.11118,-4.15444 0.006,-0.002 0.0118,-0.004 0.0167,-0.008 0.77627,1.33763 1.33314,2.95036 1.67356,4.46541",
    id: "path165-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 156.76535,226.52738 c 0.37485,-1.7084 0.45454,-4.26705 -1.03503,-5.51297 -0.96714,-0.80936 -3.47205,-0.54622 -2.89354,1.27583 0.10626,0.3349 1.27214,0.68775 1.55942,1.1004 0.59819,0.85421 0.51162,2.45398 0.56769,3.43876 0.0778,1.37651 -0.0462,2.79387 0.11118,4.15443 0.006,0.002 0.0118,0.005 0.0167,0.008 0.77431,-1.33565 1.33707,-2.95037 1.67356,-4.46442",
    id: "path167-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 152.8476,234.1136 c -1.84178,-0.45053 -1.05469,-4.48535 1.53188,-2.44601 1.55549,1.226 0.38272,2.11509 -1.53188,2.44601",
    id: "path169-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 157.05066,199.50071 c 1.9205,1.04358 3.99842,2.32441 6.12356,2.88258 1.93034,0.50634 5.59719,0.018 5.94449,-2.5726 0.33452,-2.49684 -3.14836,-3.62016 -5.03147,-3.39988 -2.34552,0.27311 -4.80911,1.87587 -6.86145,2.99222 -0.058,0.0309 -0.11806,0.0667 -0.17513,0.0977",
    id: "path171-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 157.00737,199.51666 c 0.83038,2.65333 3.39236,12.78023 8.01061,10.38606 2.24813,-1.16619 0.44077,-5.0196 -0.7379,-6.33032 -1.66469,-1.84895 -4.41951,-2.82078 -6.64697,-3.78861 -0.20858,-0.0907 -0.41912,-0.17943 -0.62574,-0.26713",
    id: "path173-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 157.01131,199.50868 c 0.82644,-2.65532 3.38842,-12.78023 8.00667,-10.38606 2.2491,1.16619 0.44077,5.01861 -0.7379,6.32932 -1.66272,1.84996 -4.41754,2.82177 -6.645,3.78962 -0.20661,0.0897 -0.41716,0.17841 -0.62377,0.26712",
    id: "path175-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 156.76535,205.57087 c 0.37485,1.7124 0.45454,4.26308 -1.03503,5.51299 -0.96517,0.81035 -3.47303,0.55518 -2.89354,-1.27185 0.10626,-0.33391 1.27214,-0.68775 1.55942,-1.09941 0.59819,-0.8552 0.51162,-2.45397 0.56769,-3.43975 0.0778,-1.37651 -0.0462,-2.79388 0.11118,-4.15443 0.006,-0.002 0.0118,-0.005 0.0167,-0.008 0.77431,1.33364 1.33608,2.94738 1.67356,4.46043",
    id: "path177-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 156.76535,193.54417 c 0.37386,-1.70642 0.45159,-4.26605 -1.03503,-5.51298 -0.96615,-0.81035 -3.475,-0.54522 -2.89354,1.27583 0.10725,0.33391 1.27115,0.68676 1.55942,1.09941 0.59819,0.8562 0.51162,2.45398 0.56769,3.43975 0.0778,1.37651 -0.0462,2.79388 0.11118,4.15443 0.006,0.002 0.0118,0.005 0.0167,0.008 0.77627,-1.33663 1.33314,-2.95036 1.67356,-4.46442",
    id: "path179-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 152.8476,201.13038 c -1.84178,-0.44953 -1.05273,-4.49032 1.53188,-2.45099 1.55745,1.22998 0.38272,2.11908 -1.53188,2.45099",
    id: "path181-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 157.04771,166.5165 c 1.91854,1.04558 4.00137,2.32739 6.12651,2.88257 1.93428,0.50635 5.59227,0.018 5.94449,-2.57159 0.33944,-2.49784 -3.14836,-3.62515 -5.03147,-3.40487 -2.34847,0.27609 -4.8101,1.88085 -6.86539,2.9962 -0.057,0.0318 -0.11609,0.0667 -0.17414,0.0977",
    id: "path183-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 157.00737,166.53244 c 0.83038,2.65532 3.39236,12.78123 8.01061,10.38606 2.24813,-1.16519 0.44077,-5.0186 -0.7379,-6.32931 -1.66469,-1.84996 -4.41951,-2.82178 -6.64697,-3.78962 -0.20858,-0.0897 -0.41912,-0.17841 -0.62574,-0.26713",
    id: "path185-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 157.00737,166.52447 c 0.83038,-2.65333 3.39236,-12.78024 8.01061,-10.38606 2.24813,1.16619 0.44077,5.0196 -0.7379,6.33032 -1.66469,1.84895 -4.41951,2.82177 -6.64697,3.78861 -0.20858,0.0907 -0.41912,0.17942 -0.62574,0.26713",
    id: "path187-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 156.76535,172.59164 c 0.37386,1.70743 0.45159,4.26606 -1.03503,5.51299 -0.96714,0.81134 -3.47205,0.54521 -2.89354,-1.27583 0.10626,-0.3349 1.27214,-0.68776 1.55942,-1.1004 0.59819,-0.85521 0.51162,-2.45399 0.56769,-3.43877 0.0778,-1.36952 -0.0659,-2.81679 0.12102,-4.15841 0.79102,1.30175 1.34296,2.95933 1.68044,4.46042",
    id: "path189-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 156.76535,160.55996 c 0.37386,-1.70643 0.45159,-4.26606 -1.03503,-5.51198 -0.96714,-0.81235 -3.47205,-0.54622 -2.89354,1.27583 0.10626,0.3349 1.27214,0.68775 1.55942,1.09941 0.59819,0.8552 0.51162,2.45397 0.56769,3.43975 0.0778,1.36953 -0.0659,2.8168 0.12102,4.15841 0.79102,-1.30175 1.34296,-2.96033 1.68044,-4.46142",
    id: "path191-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 152.8476,168.14717 c -1.84277,-0.44954 -1.05273,-4.48236 1.53188,-2.45099 1.55942,1.22698 0.37879,2.11508 -1.53188,2.45099",
    id: "path193-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 157.04771,100.55007 c 1.91951,1.04309 3.99941,2.32689 6.12258,2.88208 1.93427,0.50585 5.5962,0.0174 5.94842,-2.5721 0.34042,-2.498831 -3.14933,-3.621661 -5.03147,-3.400384 -2.34847,0.276596 -4.80911,1.877364 -6.86539,2.992224 -0.057,0.0319 -0.11707,0.0668 -0.17414,0.0982",
    id: "path195-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 157.01131,100.56601 c 0.82644,2.65333 3.39039,12.77874 8.00667,10.38557 2.2491,-1.16569 0.43979,-5.02259 -0.7379,-6.33381 -1.66076,-1.84746 -4.41754,-2.81928 -6.645,-3.78463 -0.20661,-0.0902 -0.41716,-0.17941 -0.62377,-0.26713",
    id: "path197-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 157.00737,100.55804 c 0.82842,-2.654824 3.39334,-12.785717 8.01061,-10.386059 2.24714,1.167186 0.44077,5.013117 -0.7379,6.325828 -1.66272,1.850452 -4.41951,2.824269 -6.64697,3.793101 -0.20858,0.0902 -0.41912,0.17842 -0.62574,0.26713",
    id: "path199-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 156.76535,106.62422 c 0.37386,1.70692 0.45159,4.26705 -1.03503,5.51348 -1.02519,0.86069 -3.43762,0.49987 -2.86992,-1.32318 0.0856,-0.2731 1.33116,-0.76599 1.59975,-1.19011 0.56179,-0.88909 0.4634,-2.49185 0.51456,-3.49458 0.065,-1.30174 -0.0816,-2.70316 0.11708,-3.97002 0.77627,1.33713 1.33313,2.95035 1.67356,4.46441",
    id: "path201-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 156.76535,94.593531 c 0.37485,-1.708417 0.45454,-4.266058 -1.03503,-5.512984 -0.96615,-0.809853 -3.47303,-0.546714 -2.89354,1.275831 0.10626,0.334906 1.27214,0.687752 1.55942,1.099906 0.59819,0.854706 0.51162,2.454479 0.56769,3.439261 0.0778,1.376501 -0.0462,2.793869 0.11118,4.154423 0.006,0.002 0.0118,0.0045 0.0167,0.008 0.77528,-1.335635 1.33707,-2.950358 1.67356,-4.464411",
    id: "path203-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 152.8476,102.17974 c -1.84178,-0.45053 -1.05469,-4.484844 1.53188,-2.446504 1.55549,1.226494 0.38272,2.114594 -1.53188,2.446504",
    id: "path205-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 157.05066,67.566851 c 1.9205,1.044088 3.99842,2.323407 6.12356,2.882081 1.93133,0.507343 5.59719,0.01794 5.94449,-2.572094 0.33452,-2.497838 -3.14836,-3.62017 -5.03147,-3.400388 -2.34552,0.273606 -4.80911,1.877365 -6.86145,2.991723 -0.058,0.0319 -0.11806,0.06728 -0.17513,0.09868",
    id: "path207-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 157.00737,67.582301 c 0.83038,2.654325 3.39236,12.780734 8.01061,10.386059 2.24813,-1.165192 0.44077,-5.019098 -0.7379,-6.329814 -1.66469,-1.849457 -4.41951,-2.820783 -6.64697,-3.789119 -0.20858,-0.09021 -0.41912,-0.178915 -0.62574,-0.267126",
    id: "path209-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 157.01131,67.574327 c 0.82644,-2.654825 3.38842,-12.780236 8.00667,-10.385562 2.2491,1.165193 0.43979,5.0186 -0.7379,6.329317 -1.66272,1.849456 -4.41656,2.821778 -6.645,3.789616 -0.20661,0.08971 -0.41716,0.178417 -0.62377,0.266629",
    id: "path211-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 156.76535,73.637015 c 0.37485,1.712404 0.45454,4.263567 -1.03503,5.512984 -0.96517,0.810352 -3.47402,0.555186 -2.89354,-1.271844 0.10626,-0.334905 1.27214,-0.687752 1.55942,-1.099906 0.59819,-0.854706 0.51162,-2.454479 0.56769,-3.439261 0.0778,-1.376501 -0.0462,-2.793869 0.11118,-4.154423 0.006,-0.002 0.0118,-0.0045 0.0167,-0.008 0.77431,1.33414 1.33608,2.947867 1.67356,4.460424",
    id: "path213-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 156.76535,61.609818 c 0.37485,-1.706922 0.45159,-4.266059 -1.03503,-5.512486 -0.96615,-0.810352 -3.4691,-0.549206 -2.89354,1.271844 0.10725,0.337896 1.27016,0.689247 1.55942,1.103394 0.59819,0.856202 0.51162,2.453981 0.56769,3.439759 0.0778,1.376502 -0.0462,2.793871 0.11118,4.154424 0.006,0.002 0.0118,0.0045 0.0167,0.008 0.77627,-1.336632 1.33314,-2.950359 1.67356,-4.46491",
    id: "path215-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 152.8476,69.196027 c -1.84178,-0.448035 -1.05371,-4.489827 1.53188,-2.449993 1.55745,1.228983 0.38272,2.118576 -1.53188,2.449993",
    id: "path217-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 157.04771,34.583138 c 1.91755,1.045583 4.00137,2.326895 6.12651,2.882081 1.93428,0.505847 5.59227,0.01694 5.94449,-2.571596 0.33944,-2.498336 -3.14836,-3.625652 -5.03147,-3.404873 -2.34847,0.275599 -4.8101,1.880853 -6.86539,2.996208 -0.057,0.0319 -0.11609,0.06678 -0.17414,0.09818",
    id: "path219-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 157.00737,34.598587 c 0.83038,2.654327 3.39236,12.781233 8.01061,10.38606 2.24813,-1.165193 0.44077,-5.019099 -0.7379,-6.329815 -1.66469,-1.849456 -4.41951,-2.820782 -6.64697,-3.789118 -0.20858,-0.08971 -0.41912,-0.178417 -0.62574,-0.267127",
    id: "path221-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 157.00737,34.591111 c 0.83038,-2.654325 3.39236,-12.780733 8.01061,-10.386059 2.24813,1.165192 0.44077,5.019098 -0.7379,6.329814 -1.66469,1.849457 -4.41951,2.820783 -6.64697,3.789119 -0.20858,0.09021 -0.41912,0.178915 -0.62574,0.267126",
    id: "path223-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 156.76535,40.657786 c 0.37386,1.706424 0.45159,4.26606 -1.03503,5.512984 -0.96714,0.811349 -3.47205,0.545219 -2.89354,-1.276328 0.10626,-0.334408 1.27214,-0.687753 1.55942,-1.099407 0.59819,-0.855206 0.51162,-2.45448 0.56769,-3.43976 0.0778,-1.369524 -0.0659,-2.817293 0.12102,-4.157912 0.79102,1.300749 1.34296,2.959827 1.68044,4.460423",
    id: "path225-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 156.76535,28.626602 c 0.37386,-1.706921 0.45159,-4.266058 -1.03503,-5.512984 -0.96714,-0.811349 -3.47205,-0.545716 -2.89354,1.27633 0.10626,0.334407 1.27214,0.687253 1.55942,1.099407 0.59819,0.855206 0.51162,2.453981 0.56769,3.439759 0.0778,1.369525 -0.0659,2.816795 0.12102,4.157913 0.79102,-1.301746 1.34296,-2.959828 1.68044,-4.460425",
    id: "path227-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 152.8476,36.212812 c -1.84277,-0.449033 -1.05273,-4.481854 1.53188,-2.450492 1.55942,1.225994 0.37879,2.115088 -1.53188,2.450492",
    id: "path229-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 157.04771,133.53329 c 1.91755,1.04557 4.00137,2.32739 6.12651,2.88258 1.93428,0.50534 5.59227,0.0169 5.94449,-2.5726 0.33944,-2.49883 -3.14836,-3.62116 -5.03147,-3.39989 -2.34847,0.2766 -4.80911,1.87687 -6.86539,2.99222 -0.057,0.0309 -0.11609,0.0668 -0.17414,0.0977",
    id: "path231-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 157.00737,133.54923 c 0.83038,2.65433 3.39236,12.78123 8.01061,10.38606 2.24813,-1.16519 0.44077,-5.0186 -0.7379,-6.33032 -1.66469,-1.84895 -4.41951,-2.82078 -6.64697,-3.78861 -0.20858,-0.0907 -0.41912,-0.17842 -0.62574,-0.26713",
    id: "path233-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 157.00737,133.54126 c 0.83038,-2.65383 3.39236,-12.78074 8.01061,-10.38556 2.24813,1.16519 0.44077,5.0186 -0.7379,6.32931 -1.66469,1.84946 -4.41951,2.82178 -6.64697,3.79012 -0.20858,0.0897 -0.41912,0.17741 -0.62574,0.26613",
    id: "path235-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 156.76535,139.60842 c 0.37386,1.70643 0.45159,4.26607 -1.03503,5.512 -0.96812,0.81334 -3.4691,0.54621 -2.89354,-1.27583 0.10626,-0.33491 1.27115,-0.69175 1.55942,-1.1024 0.59819,-0.8562 0.51162,-2.45498 0.56769,-3.44076 0.0778,-1.37451 -0.0462,-2.79088 0.11118,-4.15043 0.006,-0.002 0.0118,-0.004 0.0167,-0.008 0.77627,1.33763 1.33314,2.95037 1.67356,4.46541",
    id: "path237-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 156.76535,127.57675 c 0.37386,-1.70792 0.45257,-4.26506 -1.03503,-5.51299 -0.96714,-0.81135 -3.47205,-0.54572 -2.89354,1.27633 0.10626,0.33441 1.27214,0.68826 1.55942,1.09991 0.59819,0.85521 0.51162,2.45397 0.56769,3.43926 0.0778,1.36952 -0.0659,2.81679 0.12102,4.1584 0.78905,-1.30273 1.34296,-2.95982 1.68044,-4.46091",
    id: "path239-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 152.8476,135.15897 c -1.83786,-0.43757 -1.05568,-4.48634 1.53188,-2.44202 1.55155,1.22599 0.37879,2.11708 -1.53188,2.44202",
    id: "path241-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 30.399078,232.48492 c -1.920007,1.0416 -3.997924,2.3244 -6.122575,2.88058 -1.934273,0.50635 -5.595715,0.018 -5.947938,-2.57159 -0.340416,-2.49883 3.148359,-3.62117 5.030487,-3.39989 2.348479,0.2761 4.810102,1.87687 6.86539,2.99222 0.05805,0.0309 0.118063,0.0668 0.174636,0.0987",
    id: "path243-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 30.435973,232.49987 c -0.826445,2.65233 -3.390882,12.77825 -8.007655,10.38606 -2.248616,-1.16519 -0.439294,-5.02259 0.738881,-6.3343 1.661743,-1.84796 4.417049,-2.81879 6.64402,-3.78364 0.207596,-0.0907 0.417158,-0.17941 0.624754,-0.26812",
    id: "path245-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 30.439416,232.49189 c -0.827921,-2.65532 -3.392849,-12.78422 -8.011098,-10.38606 -2.246649,1.1672 -0.44077,5.01263 0.738881,6.32634 1.663219,1.84895 4.41754,2.82476 6.646972,3.79359 0.207104,0.0897 0.418142,0.17743 0.625245,0.26613",
    id: "path247-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 30.681446,238.55907 c -0.37436,1.70643 -0.451593,4.26606 1.035023,5.51199 0.967628,0.81134 3.46959,0.54422 2.893047,-1.27583 -0.10675,-0.3369 -1.269675,-0.68875 -1.55893,-1.1024 -0.598188,-0.85521 -0.5121,-2.45199 -0.56818,-3.43676 -0.07773,-1.37551 0.04674,-2.79388 -0.110685,-4.15444 -0.0059,-0.002 -0.01181,-0.004 -0.01722,-0.008 -0.774792,1.33763 -1.33215,2.95036 -1.673058,4.46541",
    id: "path249-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 30.681446,226.52738 c -0.375836,-1.7084 -0.454053,-4.26705 1.035023,-5.51297 0.967628,-0.80936 3.472049,-0.54622 2.893047,1.27583 -0.106258,0.3349 -1.270659,0.68775 -1.55893,1.1004 -0.598188,0.85421 -0.5121,2.45398 -0.56818,3.43876 -0.07773,1.37551 0.04674,2.79486 -0.110685,4.15443 -0.0059,0.002 -0.01181,0.005 -0.01722,0.008 -0.7743,-1.33565 -1.336578,-2.95037 -1.673058,-4.46442",
    id: "path251-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 34.599677,234.1136 c 1.842281,-0.45153 1.053224,-4.48434 -1.532366,-2.44601 -1.555978,1.226 -0.382722,2.11509 1.532366,2.44601",
    id: "path253-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 30.395634,199.50071 c -1.921483,1.04358 -3.99694,2.32441 -6.122574,2.88258 -1.931813,0.50634 -5.597192,0.018 -5.944495,-2.5726 -0.335005,-2.49684 3.147867,-3.62016 5.030487,-3.39988 2.346511,0.27311 4.809611,1.87687 6.861947,2.99222 0.05854,0.0309 0.117571,0.0667 0.174635,0.0977",
    id: "path255-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 30.439416,199.51666 c -0.83038,2.65432 -3.391865,12.78023 -8.011098,10.38606 -2.24714,-1.16519 -0.44077,-5.0196 0.738881,-6.33032 1.664202,-1.84895 4.418033,-2.82078 6.646972,-3.78861 0.207104,-0.0907 0.418142,-0.17943 0.625245,-0.26713",
    id: "path257-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 30.435973,199.50868 c -0.827428,-2.65532 -3.388914,-12.78023 -8.007655,-10.38606 -2.247633,1.1652 -0.439786,5.01761 0.738881,6.32932 1.662235,1.84896 4.416065,2.82277 6.64402,3.78962 0.207104,0.0897 0.41765,0.17841 0.624754,0.26712",
    id: "path259-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 30.681446,205.57087 c -0.375344,1.7124 -0.454053,4.26407 1.035023,5.51299 0.965661,0.81035 3.473525,0.55518 2.893047,-1.27185 -0.106258,-0.3349 -1.270659,-0.68775 -1.55893,-1.09941 -0.598188,-0.8552 -0.5121,-2.45397 -0.56818,-3.43975 -0.07773,-1.37651 0.04674,-2.79388 -0.110685,-4.15443 -0.0059,-0.002 -0.01181,-0.005 -0.01722,-0.008 -0.773317,1.33464 -1.335593,2.94738 -1.673058,4.46043",
    id: "path261-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 30.681446,193.54417 c -0.37436,-1.70742 -0.451593,-4.26605 1.035023,-5.51298 0.966645,-0.81035 3.475001,-0.54522 2.893047,1.27583 -0.10675,0.33391 -1.270659,0.68676 -1.55893,1.09941 -0.598681,0.8562 -0.5121,2.45398 -0.56818,3.43975 -0.07773,1.37651 0.04674,2.79388 -0.110685,4.15443 -0.0059,0.002 -0.01181,0.005 -0.01722,0.008 -0.774792,-1.33763 -1.33215,-2.94936 -1.673058,-4.46442",
    id: "path263-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 34.599677,201.13038 c 1.842774,-0.44953 1.051748,-4.49032 -1.532366,-2.45099 -1.557946,1.22998 -0.38223,2.11908 1.532366,2.45099",
    id: "path265-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 30.399078,166.5165 c -1.91804,1.04558 -4.001859,2.32739 -6.126018,2.88257 -1.934273,0.50635 -5.592764,0.018 -5.944495,-2.57159 -0.339432,-2.49784 3.146883,-3.62515 5.030487,-3.40487 2.348971,0.27609 4.810594,1.88085 6.86539,2.9962 0.05805,0.0318 0.117571,0.0678 0.174636,0.0977",
    id: "path267-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 30.439416,166.53244 c -0.83038,2.65532 -3.391373,12.78024 -8.011098,10.38606 -2.24714,-1.16419 -0.44077,-5.0186 0.738881,-6.32931 1.663711,-1.84896 4.418525,-2.82078 6.646972,-3.78962 0.207104,-0.0897 0.418142,-0.17841 0.625245,-0.26713",
    id: "path269-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 30.439416,166.52447 c -0.83038,-2.65433 -3.391865,-12.77924 -8.011098,-10.38606 -2.247633,1.16519 -0.440278,5.0196 0.738881,6.33032 1.664202,1.84895 4.418525,2.82078 6.646972,3.78861 0.207104,0.0907 0.418142,0.17942 0.625245,0.26713",
    id: "path271-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 30.681446,172.59164 c -0.37436,1.70743 -0.451593,4.26606 1.035023,5.51299 0.967628,0.81134 3.472049,0.54521 2.893047,-1.27583 -0.106258,-0.3349 -1.270659,-0.68776 -1.55893,-1.1004 -0.598681,-0.85521 -0.5121,-2.45399 -0.56818,-3.43877 -0.07723,-1.36952 0.06739,-2.8178 -0.121015,-4.15841 -0.790533,1.30274 -1.341989,2.95933 -1.679945,4.46042",
    id: "path273-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 30.681446,160.55996 c -0.37436,-1.70643 -0.451593,-4.26606 1.035023,-5.51198 0.967628,-0.81135 3.471558,-0.54622 2.893047,1.27583 -0.106258,0.3349 -1.271151,0.68775 -1.55893,1.09941 -0.598681,0.8552 -0.5121,2.45397 -0.56818,3.43975 -0.07723,1.36953 0.06739,2.8178 -0.121015,4.15841 -0.791026,-1.30274 -1.341989,-2.96033 -1.679945,-4.46142",
    id: "path275-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 34.599677,168.14717 c 1.843265,-0.45053 1.051256,-4.48136 -1.532366,-2.45099 -1.560405,1.22698 -0.378294,2.11508 1.532366,2.45099",
    id: "path277-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 30.399078,100.55007 c -1.918531,1.04309 -3.998908,2.32639 -6.122575,2.88208 -1.934273,0.50585 -5.595715,0.0174 -5.947938,-2.5721 -0.339924,-2.498831 3.148359,-3.621661 5.030487,-3.400384 2.348971,0.276596 4.80961,1.877364 6.86539,2.992224 0.05805,0.0314 0.117571,0.0673 0.174636,0.0982",
    id: "path279-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 30.435973,100.56601 c -0.826937,2.65333 -3.390882,12.77824 -8.007655,10.38557 -2.248616,-1.1652 -0.439294,-5.02259 0.738881,-6.33381 1.661251,-1.84746 4.417049,-2.81978 6.64402,-3.78463 0.207104,-0.0902 0.41765,-0.17941 0.624754,-0.26713",
    id: "path281-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 30.439416,100.55804 c -0.827921,-2.655322 -3.39334,-12.784721 -8.011098,-10.386059 -2.246649,1.167186 -0.441262,5.013117 0.738881,6.325828 1.663219,1.850452 4.418033,2.824269 6.646972,3.793101 0.207104,0.0902 0.418633,0.17842 0.625245,0.26713",
    id: "path283-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 30.681446,106.62422 c -0.37436,1.70742 -0.451593,4.26655 1.035023,5.51348 1.026168,0.86019 3.438106,0.49987 2.869926,-1.32318 -0.0851,-0.2731 -1.331658,-0.76599 -1.59976,-1.19011 -0.562277,-0.88909 -0.463891,-2.49185 -0.514068,-3.49458 -0.06543,-1.30174 0.08166,-2.70416 -0.118063,-3.97002 -0.775284,1.33762 -1.33215,2.95035 -1.673058,4.46441",
    id: "path285-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 30.681446,94.593531 c -0.375344,-1.708417 -0.454053,-4.266557 1.035023,-5.512984 0.967137,-0.809355 3.472541,-0.546714 2.893047,1.275831 -0.106258,0.334906 -1.270659,0.687752 -1.55893,1.099906 -0.598188,0.854706 -0.5121,2.454479 -0.56818,3.439261 -0.07773,1.376501 0.04674,2.794367 -0.110685,4.154423 -0.0059,0.002 -0.01181,0.0045 -0.01722,0.008 -0.7743,-1.336134 -1.336578,-2.950358 -1.673058,-4.464411",
    id: "path287-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 34.599677,102.17974 c 1.842281,-0.45152 1.053224,-4.484345 -1.532366,-2.446504 -1.55647,1.226994 -0.38223,2.114594 1.532366,2.446504",
    id: "path289-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 30.395634,67.566851 c -1.920499,1.04359 -3.997432,2.323407 -6.122574,2.882081 -1.931813,0.507343 -5.597192,0.01794 -5.944495,-2.572094 -0.335005,-2.497838 3.147867,-3.62017 5.030487,-3.400388 2.346511,0.273606 4.809118,1.877864 6.861947,2.991723 0.05854,0.0319 0.117571,0.06728 0.174635,0.09868",
    id: "path291-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 30.439416,67.582301 c -0.83038,2.654824 -3.391865,12.779737 -8.011098,10.386059 -2.24714,-1.164693 -0.440278,-5.019098 0.738881,-6.329814 1.664202,-1.848959 4.418033,-2.820783 6.646972,-3.789119 0.207104,-0.09021 0.418633,-0.178915 0.625245,-0.267126",
    id: "path293-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 30.435973,67.574327 c -0.826937,-2.654825 -3.388914,-12.779738 -8.007655,-10.385562 -2.248125,1.164694 -0.439786,5.0186 0.738881,6.329317 1.662726,1.848957 4.416065,2.821778 6.64402,3.789616 0.207104,0.08971 0.41765,0.178417 0.624754,0.266629",
    id: "path295-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 30.681446,73.637015 c -0.375344,1.712404 -0.454053,4.264065 1.035023,5.512984 0.965661,0.809854 3.473525,0.555186 2.893047,-1.271844 -0.106258,-0.334905 -1.270659,-0.687752 -1.55893,-1.099906 -0.598188,-0.854706 -0.5121,-2.454479 -0.56818,-3.439261 -0.07773,-1.376501 0.04674,-2.794368 -0.110685,-4.154423 -0.0059,-0.002 -0.01181,-0.0045 -0.01722,-0.008 -0.773317,1.334639 -1.335593,2.947369 -1.673058,4.460424",
    id: "path297-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 30.681446,61.609818 c -0.37436,-1.707421 -0.451593,-4.266059 1.035023,-5.512486 0.966152,-0.810352 3.468606,-0.549206 2.893047,1.271844 -0.10675,0.337896 -1.269183,0.689247 -1.55893,1.103394 -0.598681,0.856202 -0.5121,2.453981 -0.56818,3.439759 -0.07773,1.376003 0.04674,2.793871 -0.110685,4.154424 -0.0063,0.002 -0.01181,0.0045 -0.01722,0.008 -0.774792,-1.337629 -1.33215,-2.950359 -1.673058,-4.46491",
    id: "path299-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 34.599677,69.196027 c 1.842281,-0.449032 1.05224,-4.489827 -1.532366,-2.449993 -1.557453,1.228983 -0.38223,2.118576 1.532366,2.449993",
    id: "path301-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 30.399078,34.583138 c -1.91804,1.045583 -4.001859,2.326895 -6.126018,2.882081 -1.934273,0.505847 -5.592764,0.01694 -5.944495,-2.571596 -0.339432,-2.498336 3.146883,-3.625652 5.030487,-3.404873 2.348971,0.275599 4.810594,1.880853 6.86539,2.996208 0.05805,0.0319 0.117571,0.06678 0.174636,0.09818",
    id: "path303-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 30.439416,34.598587 c -0.83038,2.655323 -3.391865,12.780236 -8.011098,10.38606 -2.24714,-1.164694 -0.440278,-5.019099 0.738881,-6.329815 1.664202,-1.848958 4.418525,-2.820284 6.646972,-3.789118 0.207104,-0.08971 0.418633,-0.178417 0.625245,-0.267127",
    id: "path305-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 30.439416,34.591111 c -0.829888,-2.654824 -3.391865,-12.779737 -8.011098,-10.386059 -2.247633,1.164693 -0.440278,5.019098 0.738881,6.329814 1.664202,1.848959 4.418525,2.820783 6.646972,3.789119 0.207104,0.09021 0.418633,0.178915 0.625245,0.267126",
    id: "path307-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 30.681446,40.657786 c -0.37436,1.706922 -0.451593,4.26606 1.035023,5.512984 0.967628,0.811349 3.472049,0.545219 2.893047,-1.276328 -0.106258,-0.334906 -1.270659,-0.687753 -1.55893,-1.099407 -0.598681,-0.855206 -0.5121,-2.45448 -0.56818,-3.43976 -0.07723,-1.369026 0.06739,-2.817792 -0.121015,-4.157912 -0.791026,1.301746 -1.34248,2.959329 -1.679945,4.460423",
    id: "path309-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 30.681446,28.626602 c -0.37436,-1.707419 -0.451593,-4.266058 1.035023,-5.512984 0.967628,-0.811349 3.472049,-0.545716 2.893047,1.27633 -0.106258,0.334407 -1.270659,0.687253 -1.55893,1.099407 -0.598681,0.855206 -0.5121,2.453981 -0.56818,3.439759 -0.07723,1.369027 0.06739,2.817294 -0.121015,4.157913 -0.790533,-1.303242 -1.341989,-2.959329 -1.679945,-4.460425",
    id: "path311-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 34.599677,36.212812 c 1.842774,-0.450029 1.051748,-4.481355 -1.532366,-2.450492 -1.560405,1.226492 -0.378294,2.115587 1.532366,2.450492",
    id: "path313-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 30.399078,133.53329 c -1.91804,1.04557 -4.002352,2.32739 -6.126018,2.88258 -1.934765,0.50534 -5.592764,0.0169 -5.944495,-2.5726 -0.339924,-2.49883 3.147867,-3.62116 5.030487,-3.39989 2.348971,0.2766 4.80961,1.87687 6.86539,2.99222 0.05805,0.0309 0.117571,0.0668 0.174636,0.0977",
    id: "path315-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 30.439416,133.54923 c -0.83038,2.65433 -3.391865,12.77924 -8.011098,10.38606 -2.24714,-1.16519 -0.440278,-5.0186 0.738881,-6.33032 1.664202,-1.84795 4.418525,-2.82078 6.646972,-3.78861 0.207104,-0.0907 0.418142,-0.17842 0.625245,-0.26713",
    id: "path317-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 30.439416,133.54126 c -0.83038,-2.65483 -3.391865,-12.77974 -8.011098,-10.38556 -2.24714,1.16469 -0.440278,5.0186 0.738881,6.32931 1.664202,1.84896 4.418033,2.82128 6.646972,3.79012 0.207104,0.0897 0.418142,0.17741 0.625245,0.26613",
    id: "path319-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 30.681446,139.60842 c -0.37436,1.70743 -0.451593,4.26607 1.035023,5.512 0.968612,0.81334 3.469097,0.54621 2.893047,-1.27583 -0.106258,-0.33591 -1.270659,-0.69074 -1.55893,-1.1024 -0.598681,-0.8552 -0.5121,-2.45498 -0.56818,-3.44076 -0.07773,-1.37451 0.04674,-2.79088 -0.110685,-4.15043 -0.0059,-0.002 -0.01181,-0.004 -0.01722,-0.008 -0.774792,1.33763 -1.33215,2.95037 -1.673058,4.46541",
    id: "path321-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 30.681446,127.57675 c -0.372884,-1.70842 -0.452577,-4.26506 1.035023,-5.51299 0.967628,-0.81135 3.472049,-0.54522 2.893047,1.27633 -0.106258,0.33441 -1.271151,0.68776 -1.55893,1.09991 -0.598681,0.85521 -0.5121,2.45397 -0.56818,3.43926 -0.07723,1.36902 0.06739,2.81779 -0.121015,4.1584 -0.789058,-1.30373 -1.341989,-2.95932 -1.679945,-4.46091",
    id: "path323-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 34.599677,135.15897 c 1.837854,-0.43857 1.054208,-4.48634 -1.532366,-2.44202 -1.55155,1.22599 -0.378787,2.11708 1.532366,2.44202",
    id: "path325-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 83.124248,159.22532 h 0.02705",
    id: "path327-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0f0c",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 85.658185,124.18034 c 1.660759,0 16.129925,-0.13904 16.129925,0.13706 0,3.33111 0,6.66222 0,9.99334 0,1.92371 0,3.84842 0,5.77214 0,0.44156 0.31385,2.60449 0,2.94537 -1.02617,1.11735 -16.129925,-0.65785 -16.129925,-0.13655 0,-6.23762 0,-12.47424 0,-18.71136",
    id: "path329-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 86.666151,127.71429 c 0.67247,-0.78543 1.344448,-1.57086 2.016426,-2.35579 0.335989,1.17765 0.671978,2.35579 1.007966,3.53395 -1.007966,-0.39272 -2.015933,-0.78544 -3.024392,-1.17816",
    id: "path331-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 98.764704,125.3585 c 0.670994,0.78493 1.343956,1.57036 2.014946,2.35579 -1.007471,0.39272 -2.014946,0.78544 -3.024389,1.17816 0.336481,-1.17816 0.672962,-2.3563 1.009443,-3.53395",
    id: "path333-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 98.827671,141.78332 c 0.671978,-0.78543 1.343959,-1.57087 2.016919,-2.3563 -1.009444,-0.39272 -2.016919,-0.78543 -3.024394,-1.17815 0.335497,1.17815 0.670994,2.3563 1.007475,3.53445",
    id: "path335-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 88.682577,141.8501 c -0.671978,-0.78543 -1.343956,-1.56986 -2.016426,-2.3553 1.00846,-0.39272 2.016426,-0.78543 3.024392,-1.17815 -0.335988,1.17815 -0.671977,2.35531 -1.007966,3.53345",
    id: "path337-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.997833,
      strokeMiterlimit: 4
    },
    d: "m 93.723395,124.18034 c -0.664599,2.32989 -1.329198,4.65928 -1.993797,6.98867 -0.247442,0.86716 -5.10772,2.06026 -6.071413,2.43504 0.963693,0.37578 5.823971,1.56788 6.071413,2.43604 0.664599,2.32839 1.329198,4.65877 1.993797,6.98816 0.66509,-2.32939 1.329197,-4.65977 1.993304,-6.98816 0.247933,-0.86816 5.108211,-2.06026 6.071411,-2.43604 -0.9632,-0.37478 -5.823478,-1.56788 -6.071411,-2.43504 -0.664107,-2.32939 -1.328214,-4.65878 -1.993304,-6.98867",
    id: "path339-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 143.12212,127.71429 c -0.3286,1.53399 -0.65623,3.06798 -0.98484,4.60196 -0.11413,0.53476 -3.43762,1.10739 -4.05548,1.2878 0.61786,0.18141 3.94135,0.75353 4.05548,1.28779 0.32861,1.53399 0.65624,3.06798 0.98484,4.60296 0.32763,-1.53498 0.65624,-3.06897 0.98485,-4.60296 0.11413,-0.53426 3.43762,-1.10638 4.05548,-1.28779 -0.61786,-0.18041 -3.94135,-0.75304 -4.05548,-1.2878 -0.32861,-1.53398 -0.65722,-3.06797 -0.98485,-4.60196",
    id: "path341-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 143.1113,111.21472 c -0.32762,1.53399 -0.65624,3.06797 -0.98386,4.60245 -0.11412,0.53426 -3.43761,1.10689 -4.05646,1.28729 0.61885,0.18092 3.94234,0.75305 4.05646,1.2878 0.32762,1.53398 0.65624,3.06847 0.98386,4.60246 0.32861,-1.53399 0.65722,-3.06848 0.98584,-4.60246 0.11412,-0.53475 3.43761,-1.10688 4.05548,-1.2878 -0.61787,-0.1804 -3.94136,-0.75303 -4.05548,-1.28729 -0.32862,-1.53448 -0.65723,-3.06846 -0.98584,-4.60245",
    id: "path343-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 143.13885,144.19444 c -0.32861,1.53399 -0.65623,3.06798 -0.98386,4.60197 -0.11512,0.53425 -3.43762,1.10738 -4.05646,1.28779 0.61787,0.1804 3.94134,0.75353 4.05646,1.28779 0.32763,1.53399 0.65525,3.06797 0.98386,4.60295 0.32862,-1.53498 0.65722,-3.06896 0.98484,-4.60295 0.11512,-0.53426 3.43861,-1.10739 4.05647,-1.28779 -0.61786,-0.18041 -3.94135,-0.75354 -4.05647,-1.28779 -0.32762,-1.53399 -0.65622,-3.06798 -0.98484,-4.60197",
    id: "path345-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 129.00764,127.71429 c -0.32763,1.53399 -0.65624,3.06798 -0.98484,4.60196 -0.11413,0.53476 -3.43762,1.10739 -4.05548,1.2878 0.61786,0.18141 3.94135,0.75353 4.05548,1.28779 0.3286,1.53399 0.65721,3.06798 0.98484,4.60296 0.32861,-1.53498 0.65623,-3.06897 0.98485,-4.60296 0.11413,-0.53426 3.43762,-1.10638 4.05548,-1.28779 -0.61786,-0.18041 -3.94135,-0.75304 -4.05548,-1.2878 -0.32862,-1.53398 -0.65624,-3.06797 -0.98485,-4.60196",
    id: "path347-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 128.9978,111.21472 c -0.32762,1.53399 -0.65624,3.06797 -0.98485,4.60245 -0.11412,0.53426 -3.43761,1.10689 -4.05548,1.28729 0.61787,0.18092 3.94136,0.75305 4.05548,1.2878 0.32861,1.53398 0.65723,3.06847 0.98485,4.60246 0.32861,-1.53399 0.65624,-3.06848 0.98485,-4.60246 0.11412,-0.53475 3.43761,-1.10688 4.05548,-1.2878 -0.61787,-0.1804 -3.94136,-0.75303 -4.05548,-1.28729 -0.32861,-1.53448 -0.65624,-3.06846 -0.98485,-4.60245",
    id: "path349-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 129.02437,144.19444 c -0.32763,1.53399 -0.65525,3.06798 -0.98386,4.60197 -0.11413,0.53425 -3.43762,1.10738 -4.05647,1.28779 0.61885,0.1804 3.94234,0.75353 4.05647,1.28779 0.32861,1.53399 0.65623,3.06797 0.98386,4.60295 0.32861,-1.53498 0.65721,-3.06896 0.98582,-4.60295 0.11414,-0.53426 3.43762,-1.10739 4.05549,-1.28779 -0.61787,-0.18041 -3.94135,-0.75354 -4.05549,-1.28779 -0.32861,-1.53399 -0.65721,-3.06798 -0.98582,-4.60197",
    id: "path351-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 100.77965,176.01147 c -0.32762,1.53399 -0.65525,3.06797 -0.983859,4.60296 -0.114128,0.53425 -3.437614,1.10638 -4.055479,1.28679 0.617865,0.18042 3.941351,0.75354 4.055479,1.28879 0.328609,1.53299 0.656239,3.06797 0.983859,4.60097 0.32861,-1.533 0.65722,-3.06798 0.98583,-4.60097 0.11413,-0.53525 3.43762,-1.10837 4.05548,-1.28879 -0.61786,-0.18041 -3.94135,-0.75254 -4.05548,-1.28679 -0.32861,-1.53499 -0.65722,-3.06897 -0.98583,-4.60296",
    id: "path353-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 86.666151,176.01147 c -0.328118,1.53399 -0.656235,3.06797 -0.984354,4.60296 -0.114619,0.53425 -3.438106,1.10638 -4.056463,1.28679 0.618357,0.18042 3.941844,0.75354 4.056463,1.28879 0.328119,1.53299 0.656236,3.06797 0.984354,4.60097 0.328611,-1.533 0.656728,-3.06798 0.984846,-4.60097 0.114621,-0.53525 3.438107,-1.10837 4.055972,-1.28879 -0.617865,-0.18041 -3.941352,-0.75254 -4.055972,-1.28679 -0.328118,-1.53499 -0.656235,-3.06897 -0.984846,-4.60296",
    id: "path355-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 114.8843,175.98356 c -0.32861,1.53498 -0.65722,3.06897 -0.98485,4.60296 -0.11413,0.53425 -3.43859,1.10639 -4.05646,1.28779 0.61787,0.18041 3.94233,0.75353 4.05646,1.28779 0.32763,1.53399 0.65624,3.06798 0.98485,4.60196 0.32861,-1.53398 0.65624,-3.06797 0.98387,-4.60196 0.1151,-0.53426 3.4376,-1.10738 4.05645,-1.28779 -0.61885,-0.1814 -3.94135,-0.75354 -4.05645,-1.28779 -0.32763,-1.53399 -0.65526,-3.06798 -0.98387,-4.60296",
    id: "path357-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 72.592496,176.02742 c -0.328118,1.53399 -0.656237,3.06797 -0.984354,4.60195 -0.114128,0.53526 -3.437615,1.10739 -4.055972,1.2878 0.618357,0.18041 3.941844,0.75254 4.055972,1.28779 0.328117,1.53399 0.656236,3.06797 0.984354,4.60196 0.32861,-1.53399 0.656728,-3.06797 0.985338,-4.60196 0.114128,-0.53525 3.437614,-1.10738 4.055479,-1.28779 -0.617865,-0.18041 -3.941351,-0.75254 -4.055479,-1.2878 -0.32861,-1.53398 -0.656729,-3.06796 -0.985338,-4.60195",
    id: "path359-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 143.09163,176.00748 c -0.32861,1.53498 -0.65624,3.06797 -0.98386,4.60296 -0.11512,0.53426 -3.4386,1.10638 -4.05746,1.28779 0.61886,0.17941 3.94234,0.75254 4.05746,1.2878 0.32762,1.53298 0.65525,3.06797 0.98386,4.60096 0.32861,-1.53299 0.65624,-3.06798 0.98484,-4.60096 0.11413,-0.53526 3.43762,-1.10839 4.05647,-1.2878 -0.61885,-0.18141 -3.94234,-0.75353 -4.05647,-1.28779 -0.3286,-1.53499 -0.65623,-3.06798 -0.98484,-4.60296",
    id: "path361-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 128.97714,176.00748 c -0.32762,1.53498 -0.65623,3.06797 -0.98386,4.60296 -0.11512,0.53426 -3.43762,1.10638 -4.05647,1.28779 0.61885,0.17941 3.94135,0.75254 4.05647,1.2878 0.32763,1.53298 0.65624,3.06797 0.98386,4.60096 0.32862,-1.53299 0.65722,-3.06798 0.98583,-4.60096 0.11413,-0.53526 3.43762,-1.10839 4.05548,-1.2878 -0.61786,-0.18141 -3.94135,-0.75353 -4.05548,-1.28779 -0.32861,-1.53499 -0.65721,-3.06798 -0.98583,-4.60296",
    id: "path363-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 100.77965,192.50357 c -0.32762,1.53399 -0.65525,3.06798 -0.983859,4.60196 -0.114128,0.53426 -3.437614,1.10738 -4.055479,1.2878 0.617865,0.18041 3.941351,0.75254 4.055479,1.28779 0.328609,1.53399 0.656239,3.06797 0.983859,4.60196 0.32861,-1.53399 0.65722,-3.06797 0.98583,-4.60196 0.11413,-0.53525 3.43762,-1.10738 4.05548,-1.28779 -0.61786,-0.18042 -3.94135,-0.75354 -4.05548,-1.2878 -0.32861,-1.53398 -0.65722,-3.06797 -0.98583,-4.60196",
    id: "path365-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 86.666151,192.50357 c -0.328118,1.53399 -0.656235,3.06798 -0.984354,4.60196 -0.114619,0.53426 -3.438106,1.10738 -4.056463,1.2878 0.618357,0.18041 3.941844,0.75254 4.056463,1.28779 0.328119,1.53399 0.656236,3.06797 0.984354,4.60196 0.328611,-1.53399 0.656728,-3.06797 0.984846,-4.60196 0.114621,-0.53525 3.438107,-1.10738 4.055972,-1.28779 -0.617865,-0.18042 -3.941352,-0.75354 -4.055972,-1.2878 -0.328118,-1.53398 -0.656235,-3.06797 -0.984846,-4.60196",
    id: "path367-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 114.8843,192.47567 c -0.32861,1.53398 -0.65722,3.06797 -0.98485,4.60296 -0.11413,0.53424 -3.43859,1.10638 -4.05646,1.28778 0.61787,0.17942 3.94233,0.75255 4.05646,1.28779 0.32763,1.533 0.65624,3.06798 0.98485,4.60098 0.32861,-1.533 0.65624,-3.06798 0.98387,-4.60098 0.1151,-0.53524 3.4376,-1.10837 4.05645,-1.28779 -0.61885,-0.1814 -3.94135,-0.75354 -4.05645,-1.28778 -0.32763,-1.53499 -0.65526,-3.06898 -0.98387,-4.60296",
    id: "path369-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 72.592496,192.51952 c -0.328118,1.53399 -0.656237,3.06798 -0.984354,4.60197 -0.114128,0.53425 -3.437615,1.10738 -4.055972,1.28779 0.618357,0.1804 3.941844,0.75253 4.055972,1.28779 0.328117,1.53398 0.656236,3.06797 0.984354,4.60195 0.32861,-1.53398 0.656728,-3.06797 0.985338,-4.60195 0.114128,-0.53526 3.437614,-1.10739 4.055479,-1.28779 -0.617865,-0.18041 -3.941351,-0.75354 -4.055479,-1.28779 -0.32861,-1.53399 -0.656729,-3.06798 -0.985338,-4.60197",
    id: "path371-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 143.09163,192.49959 c -0.32861,1.53399 -0.65624,3.06797 -0.98386,4.60196 -0.11512,0.53525 -3.4386,1.10738 -4.05746,1.2878 0.61886,0.1804 3.94234,0.75353 4.05746,1.28778 0.32762,1.53399 0.65525,3.06797 0.98386,4.60196 0.32861,-1.53399 0.65624,-3.06797 0.98484,-4.60196 0.11413,-0.53425 3.43762,-1.10738 4.05647,-1.28778 -0.61885,-0.18042 -3.94234,-0.75255 -4.05647,-1.2878 -0.3286,-1.53399 -0.65623,-3.06797 -0.98484,-4.60196",
    id: "path373-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 128.97714,192.49959 c -0.32762,1.53399 -0.65623,3.06797 -0.98386,4.60196 -0.11512,0.53525 -3.43762,1.10738 -4.05647,1.2878 0.61885,0.1804 3.94135,0.75353 4.05647,1.28778 0.32763,1.53399 0.65624,3.06797 0.98386,4.60196 0.32862,-1.53399 0.65722,-3.06797 0.98583,-4.60196 0.11413,-0.53425 3.43762,-1.10738 4.05548,-1.28778 -0.61786,-0.18042 -3.94135,-0.75255 -4.05548,-1.2878 -0.32861,-1.53399 -0.65721,-3.06797 -0.98583,-4.60196",
    id: "path375-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 100.77965,208.99568 c -0.32762,1.53299 -0.65525,3.06798 -0.983859,4.60197 -0.114128,0.53424 -3.437614,1.10738 -4.055479,1.28679 0.617865,0.1814 3.941351,0.75353 4.055479,1.28779 0.328609,1.53498 0.656239,3.06798 0.983859,4.60295 0.32861,-1.53497 0.65722,-3.06797 0.98583,-4.60295 0.11413,-0.53426 3.43762,-1.10639 4.05548,-1.28779 -0.61786,-0.17941 -3.94135,-0.75255 -4.05548,-1.28679 -0.32861,-1.53399 -0.65722,-3.06898 -0.98583,-4.60197",
    id: "path377-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 86.666151,208.99568 c -0.328118,1.53299 -0.656235,3.06798 -0.984354,4.60197 -0.114619,0.53424 -3.438106,1.10738 -4.056463,1.28679 0.618357,0.1814 3.941844,0.75353 4.056463,1.28779 0.328119,1.53498 0.656236,3.06798 0.984354,4.60295 0.328611,-1.53497 0.656728,-3.06797 0.984846,-4.60295 0.114621,-0.53426 3.438107,-1.10639 4.055972,-1.28779 -0.617865,-0.17941 -3.941352,-0.75255 -4.055972,-1.28679 -0.328118,-1.53399 -0.656235,-3.06898 -0.984846,-4.60197",
    id: "path379-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 114.8843,208.96777 c -0.32861,1.53399 -0.65722,3.06797 -0.98485,4.60296 -0.11413,0.53426 -3.43859,1.10638 -4.05646,1.28679 0.61787,0.18042 3.94233,0.75255 4.05646,1.2878 0.32763,1.53398 0.65624,3.06797 0.98485,4.60196 0.32861,-1.53399 0.65624,-3.06798 0.98387,-4.60196 0.1151,-0.53525 3.4376,-1.10738 4.05645,-1.2878 -0.61885,-0.18041 -3.94135,-0.75253 -4.05645,-1.28679 -0.32763,-1.53499 -0.65526,-3.06897 -0.98387,-4.60296",
    id: "path381-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 72.592496,209.01163 c -0.328118,1.53298 -0.656237,3.06797 -0.984354,4.60096 -0.114128,0.53425 -3.437615,1.10739 -4.055972,1.28779 0.618357,0.18141 3.941844,0.75354 4.055972,1.28779 0.328117,1.53499 0.656236,3.06798 0.984354,4.60297 0.32861,-1.53499 0.656728,-3.06798 0.985338,-4.60297 0.114128,-0.53425 3.437614,-1.10638 4.055479,-1.28779 -0.617865,-0.1804 -3.941351,-0.75354 -4.055479,-1.28779 -0.32861,-1.53299 -0.656729,-3.06798 -0.985338,-4.60096",
    id: "path383-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 143.09163,208.99169 c -0.32861,1.53299 -0.65624,3.06798 -0.98386,4.60196 -0.11512,0.53426 -3.4386,1.10739 -4.05746,1.2878 0.61886,0.18041 3.94234,0.75253 4.05746,1.28679 0.32762,1.53499 0.65525,3.06798 0.98386,4.60296 0.32861,-1.53498 0.65624,-3.06797 0.98484,-4.60296 0.11413,-0.53426 3.43762,-1.10638 4.05647,-1.28679 -0.61885,-0.18041 -3.94234,-0.75354 -4.05647,-1.2878 -0.3286,-1.53398 -0.65623,-3.06897 -0.98484,-4.60196",
    id: "path385-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 128.97714,208.99169 c -0.32762,1.53299 -0.65623,3.06798 -0.98386,4.60196 -0.11512,0.53426 -3.43762,1.10739 -4.05647,1.2878 0.61885,0.18041 3.94135,0.75253 4.05647,1.28679 0.32763,1.53499 0.65624,3.06798 0.98386,4.60296 0.32862,-1.53498 0.65722,-3.06797 0.98583,-4.60296 0.11413,-0.53426 3.43762,-1.10638 4.05548,-1.28679 -0.61786,-0.18041 -3.94135,-0.75354 -4.05548,-1.2878 -0.32861,-1.53398 -0.65721,-3.06897 -0.98583,-4.60196",
    id: "path387-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 100.77965,160.69751 c -0.32762,1.53499 -0.65525,3.06797 -0.983859,4.60296 -0.114128,0.53426 -3.437614,1.10638 -4.055479,1.28779 0.617865,0.18042 3.941351,0.75254 4.055479,1.2878 0.328609,1.53298 0.656239,3.06797 0.983859,4.60096 0.32861,-1.53299 0.65722,-3.06798 0.98583,-4.60096 0.11413,-0.53526 3.43762,-1.10838 4.05548,-1.2878 -0.61786,-0.18141 -3.94135,-0.75353 -4.05548,-1.28779 -0.32861,-1.53499 -0.65722,-3.06797 -0.98583,-4.60296",
    id: "path389-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 86.666151,160.69751 c -0.328118,1.53499 -0.656235,3.06797 -0.984354,4.60296 -0.114619,0.53426 -3.438106,1.10638 -4.056463,1.28779 0.618357,0.17942 3.941844,0.75254 4.056463,1.2878 0.328119,1.53298 0.656236,3.06797 0.984354,4.60096 0.328611,-1.53299 0.656728,-3.06798 0.984846,-4.60096 0.114621,-0.53526 3.438107,-1.10838 4.055972,-1.2878 -0.617865,-0.18141 -3.941352,-0.75353 -4.055972,-1.28779 -0.328118,-1.53499 -0.656235,-3.06797 -0.984846,-4.60296",
    id: "path391-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 114.8843,160.6706 c -0.32861,1.53399 -0.65722,3.06798 -0.98485,4.60197 -0.11413,0.53424 -3.43859,1.10738 -4.05646,1.28778 0.61787,0.18041 3.94233,0.75354 4.05646,1.28779 0.32763,1.53399 0.65624,3.06798 0.98485,4.60196 0.32861,-1.53398 0.65624,-3.06797 0.98387,-4.60196 0.1151,-0.53425 3.4376,-1.10738 4.05645,-1.28779 -0.61885,-0.1804 -3.94135,-0.75354 -4.05645,-1.28778 -0.32763,-1.53399 -0.65526,-3.06798 -0.98387,-4.60197",
    id: "path393-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 72.592496,160.71346 c -0.328118,1.53399 -0.656237,3.06798 -0.984354,4.60295 -0.114128,0.53426 -3.437615,1.10639 -4.055972,1.28681 0.618357,0.1804 3.941844,0.75353 4.055972,1.28878 0.328117,1.533 0.656236,3.06797 0.984354,4.60096 0.32861,-1.53299 0.656728,-3.06796 0.985338,-4.60096 0.114128,-0.53525 3.437614,-1.10838 4.055479,-1.28878 -0.617865,-0.18042 -3.941351,-0.75255 -4.055479,-1.28681 -0.32861,-1.53497 -0.656729,-3.06896 -0.985338,-4.60295",
    id: "path395-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 143.09163,160.69353 c -0.32861,1.53497 -0.65624,3.06797 -0.98386,4.60295 -0.11512,0.53426 -3.4386,1.10639 -4.05746,1.28779 0.61886,0.18042 3.94234,0.75255 4.05746,1.2878 0.32762,1.53298 0.65525,3.06797 0.98386,4.60196 0.32861,-1.53399 0.65624,-3.06898 0.98484,-4.60196 0.11413,-0.53525 3.43762,-1.10738 4.05647,-1.2878 -0.61885,-0.1814 -3.94234,-0.75353 -4.05647,-1.28779 -0.3286,-1.53498 -0.65623,-3.06798 -0.98484,-4.60295",
    id: "path397-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 128.97714,160.69353 c -0.32762,1.53497 -0.65623,3.06797 -0.98386,4.60295 -0.11512,0.53426 -3.43762,1.10639 -4.05647,1.28779 0.61885,0.18042 3.94135,0.75255 4.05647,1.2878 0.32763,1.53298 0.65624,3.06797 0.98386,4.60196 0.32862,-1.53399 0.65722,-3.06898 0.98583,-4.60196 0.11413,-0.53525 3.43762,-1.10738 4.05548,-1.2878 -0.61786,-0.1814 -3.94135,-0.75353 -4.05548,-1.28779 -0.32861,-1.53498 -0.65721,-3.06798 -0.98583,-4.60295",
    id: "path399-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 86.666151,94.731082 c -0.328118,1.533987 -0.656235,3.067974 -0.984354,4.601961 -0.114619,0.534753 -3.438106,1.107377 -4.056463,1.287797 0.618357,0.18041 3.941844,0.75303 4.056463,1.28779 0.328119,1.53398 0.656236,3.06797 0.984354,4.60196 0.328611,-1.53399 0.656728,-3.06798 0.984846,-4.60196 0.114621,-0.53476 3.438107,-1.10738 4.055972,-1.28779 -0.617865,-0.18042 -3.941352,-0.753044 -4.055972,-1.287797 -0.328118,-1.533987 -0.656235,-3.067974 -0.984846,-4.601961",
    id: "path401-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 72.552158,94.731082 c -0.328118,1.533987 -0.656237,3.067974 -0.984354,4.601961 -0.114128,0.534753 -3.438107,1.107377 -4.056464,1.287797 0.618357,0.18041 3.942335,0.75303 4.056464,1.28779 0.328117,1.53398 0.656236,3.06797 0.984354,4.60196 0.32861,-1.53399 0.656727,-3.06798 0.984846,-4.60196 0.114619,-0.53476 3.438105,-1.10738 4.055971,-1.28779 -0.617866,-0.18042 -3.941352,-0.753044 -4.055971,-1.287797 -0.328119,-1.533987 -0.656237,-3.067974 -0.984846,-4.601961",
    id: "path403-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 114.8902,94.731082 c -0.32762,1.533987 -0.65525,3.067974 -0.98386,4.601961 -0.11412,0.534753 -3.43761,1.107377 -4.05646,1.287797 0.61885,0.18041 3.94234,0.75303 4.05646,1.28779 0.32861,1.53398 0.65624,3.06797 0.98386,4.60196 0.32861,-1.53399 0.65723,-3.06798 0.98584,-4.60196 0.11412,-0.53476 3.43761,-1.10738 4.05547,-1.28779 -0.61786,-0.18042 -3.94135,-0.753044 -4.05547,-1.287797 -0.32861,-1.533987 -0.65723,-3.067974 -0.98584,-4.601961",
    id: "path405-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 100.77375,94.731082 c -0.32861,1.533987 -0.65722,3.067974 -0.984845,4.601961 -0.114129,0.534753 -3.437615,1.107377 -4.056465,1.287797 0.61885,0.18041 3.942336,0.75303 4.056465,1.28779 0.327625,1.53398 0.656235,3.06797 0.984845,4.60196 0.32861,-1.53399 0.65624,-3.06798 0.98485,-4.60196 0.11412,-0.53476 3.43761,-1.10738 4.05548,-1.28779 -0.61787,-0.18042 -3.94136,-0.753044 -4.05548,-1.287797 -0.32861,-1.533987 -0.65624,-3.067974 -0.98485,-4.601961",
    id: "path407-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 72.559537,78.227513 c -0.328119,1.533988 -0.656729,3.067975 -0.984846,4.601962 -0.114621,0.534752 -3.437615,1.107381 -4.055972,1.287792 0.618357,0.180908 3.941843,0.753039 4.055972,1.287791 0.328117,1.533987 0.656727,3.067974 0.984846,4.60246 0.328117,-1.534486 0.656236,-3.068473 0.984846,-4.60246 0.114127,-0.534752 3.437613,-1.106883 4.055479,-1.287791 -0.617866,-0.180411 -3.941352,-0.75304 -4.055479,-1.287792 -0.32861,-1.533987 -0.656729,-3.067974 -0.984846,-4.601962",
    id: "path409-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 86.666151,78.238976 c -0.328118,1.533987 -0.656235,3.068472 -0.984354,4.60246 -0.114619,0.534752 -3.438106,1.106883 -4.056463,1.287792 0.618357,0.180409 3.941844,0.753039 4.056463,1.287791 0.328119,1.533987 0.656236,3.067974 0.984354,4.601962 0.328611,-1.533988 0.656728,-3.067975 0.984846,-4.601962 0.114621,-0.534752 3.438107,-1.107381 4.055972,-1.287791 -0.617865,-0.180909 -3.941352,-0.75304 -4.055972,-1.287792 -0.328118,-1.533988 -0.656235,-3.068473 -0.984846,-4.60246",
    id: "path411-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 100.77965,78.238976 c -0.32762,1.533987 -0.65525,3.068472 -0.983859,4.60246 -0.114128,0.534752 -3.437614,1.106883 -4.055479,1.287792 0.617865,0.180409 3.941351,0.753039 4.055479,1.287791 0.328609,1.533987 0.656239,3.067974 0.983859,4.601962 0.32861,-1.533988 0.65722,-3.067975 0.98583,-4.601962 0.11413,-0.534752 3.43762,-1.107381 4.05548,-1.287791 -0.61786,-0.180909 -3.94135,-0.75304 -4.05548,-1.287792 -0.32861,-1.533988 -0.65722,-3.068473 -0.98583,-4.60246",
    id: "path413-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 114.89414,78.238976 c -0.32861,1.533987 -0.65723,3.068472 -0.98485,4.60246 -0.11412,0.534752 -3.43761,1.106883 -4.05646,1.287792 0.61885,0.180409 3.94234,0.753039 4.05646,1.287791 0.32762,1.533987 0.65624,3.067974 0.98485,4.601962 0.32861,-1.533988 0.65624,-3.067975 0.98485,-4.601962 0.11412,-0.534752 3.43761,-1.107381 4.05645,-1.287791 -0.61884,-0.180909 -3.94233,-0.75304 -4.05645,-1.287792 -0.32861,-1.533988 -0.65624,-3.068473 -0.98485,-4.60246",
    id: "path415-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 143.10835,94.711147 c -0.32762,1.533987 -0.65624,3.067974 -0.98485,4.60246 -0.11412,0.534752 -3.43761,1.106883 -4.05547,1.287293 0.61786,0.18091 3.94135,0.75354 4.05547,1.28779 0.32861,1.53399 0.65723,3.06798 0.98485,4.60246 0.32763,-1.53448 0.65624,-3.06847 0.98485,-4.60246 0.11413,-0.53425 3.43761,-1.10688 4.05548,-1.28779 -0.61787,-0.18041 -3.94135,-0.752541 -4.05548,-1.287293 -0.32861,-1.534486 -0.65722,-3.068473 -0.98485,-4.60246",
    id: "path417-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 143.12212,78.238976 c -0.3286,1.533987 -0.65623,3.068472 -0.98484,4.60246 -0.11413,0.534752 -3.43762,1.106883 -4.05548,1.287792 0.61786,0.180409 3.94135,0.753039 4.05548,1.287791 0.32861,1.533987 0.65624,3.067974 0.98484,4.601962 0.32763,-1.533988 0.65624,-3.067975 0.98485,-4.601962 0.11413,-0.534752 3.43762,-1.107381 4.05548,-1.287791 -0.61786,-0.180909 -3.94135,-0.75304 -4.05548,-1.287792 -0.32861,-1.533988 -0.65722,-3.068473 -0.98485,-4.60246",
    id: "path419-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 128.99485,94.711147 c -0.32861,1.533987 -0.65722,3.067974 -0.98485,4.60246 -0.11413,0.534752 -3.43761,1.106883 -4.05645,1.287293 0.61884,0.18091 3.94232,0.75354 4.05645,1.28779 0.32763,1.53399 0.65624,3.06798 0.98485,4.60246 0.32861,-1.53448 0.65624,-3.06847 0.98386,-4.60246 0.11511,-0.53425 3.4386,-1.10688 4.05646,-1.28779 -0.61786,-0.18041 -3.94135,-0.752541 -4.05646,-1.287293 -0.32762,-1.534486 -0.65525,-3.068473 -0.98386,-4.60246",
    id: "path421-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 129.00764,78.238976 c -0.32763,1.533987 -0.65624,3.068472 -0.98484,4.60246 -0.11413,0.534752 -3.43762,1.106883 -4.05548,1.287792 0.61786,0.180409 3.94135,0.753039 4.05548,1.287791 0.3286,1.533987 0.65721,3.067974 0.98484,4.601962 0.32861,-1.533988 0.65623,-3.067975 0.98485,-4.601962 0.11413,-0.534752 3.43762,-1.107381 4.05548,-1.287791 -0.61786,-0.180909 -3.94135,-0.75304 -4.05548,-1.287792 -0.32862,-1.533988 -0.65624,-3.068473 -0.98485,-4.60246",
    id: "path423-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 86.666151,61.747369 c -0.328118,1.533986 -0.656235,3.067974 -0.984354,4.602459 -0.114619,0.534255 -3.438106,1.106883 -4.056463,1.287792 0.618357,0.180411 3.941844,0.752541 4.056463,1.287293 0.328119,1.533987 0.656236,3.068473 0.984354,4.60246 0.328611,-1.533987 0.656728,-3.068473 0.984846,-4.60246 0.114621,-0.534752 3.438107,-1.106882 4.055972,-1.287293 -0.617865,-0.180909 -3.941352,-0.753537 -4.055972,-1.287792 -0.328118,-1.534485 -0.656235,-3.068473 -0.984846,-4.602459",
    id: "path425-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 72.552158,61.747369 c -0.328118,1.533986 -0.656237,3.067974 -0.984354,4.602459 -0.114128,0.534255 -3.438107,1.106883 -4.056464,1.287792 0.618357,0.180411 3.942335,0.752541 4.056464,1.287293 0.328117,1.533987 0.656236,3.068473 0.984354,4.60246 0.32861,-1.533987 0.656727,-3.068473 0.984846,-4.60246 0.114619,-0.534752 3.438105,-1.106882 4.055971,-1.287293 -0.617866,-0.180909 -3.941352,-0.753537 -4.055971,-1.287792 -0.328119,-1.534485 -0.656237,-3.068473 -0.984846,-4.602459",
    id: "path427-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 114.8902,61.747369 c -0.32762,1.533986 -0.65525,3.067974 -0.98386,4.602459 -0.11412,0.534255 -3.43761,1.106883 -4.05646,1.287792 0.61885,0.180411 3.94234,0.752541 4.05646,1.287293 0.32861,1.533987 0.65624,3.068473 0.98386,4.60246 0.32861,-1.533987 0.65723,-3.068473 0.98584,-4.60246 0.11412,-0.534752 3.43761,-1.106882 4.05547,-1.287293 -0.61786,-0.180909 -3.94135,-0.753537 -4.05547,-1.287792 -0.32861,-1.534485 -0.65723,-3.068473 -0.98584,-4.602459",
    id: "path429-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 100.77375,61.747369 c -0.32861,1.533986 -0.65722,3.067974 -0.984845,4.602459 -0.114129,0.534255 -3.437615,1.106883 -4.056465,1.287792 0.61885,0.180411 3.942336,0.752541 4.056465,1.287293 0.327625,1.533987 0.656235,3.068473 0.984845,4.60246 0.32861,-1.533987 0.65624,-3.068473 0.98485,-4.60246 0.11412,-0.534752 3.43761,-1.106882 4.05548,-1.287293 -0.61787,-0.180909 -3.94136,-0.753537 -4.05548,-1.287792 -0.32861,-1.534485 -0.65624,-3.068473 -0.98485,-4.602459",
    id: "path431-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 72.559537,45.2438 c -0.328119,1.533987 -0.656729,3.067975 -0.984846,4.601961 -0.114129,0.534753 -3.437615,1.107381 -4.055972,1.287792 0.618357,0.180909 3.941351,0.753537 4.055972,1.287792 0.328117,1.533987 0.656727,3.067974 0.984846,4.601961 0.328117,-1.533987 0.656236,-3.067974 0.984846,-4.601961 0.114127,-0.534255 3.437613,-1.106883 4.055479,-1.287792 -0.617866,-0.180411 -3.941352,-0.753039 -4.055479,-1.287792 -0.32861,-1.533986 -0.656729,-3.067974 -0.984846,-4.601961",
    id: "path433-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 86.666151,45.255761 c -0.328118,1.533987 -0.656235,3.067974 -0.984354,4.601961 -0.114619,0.534753 -3.438106,1.107382 -4.056463,1.287792 0.618357,0.180411 3.941844,0.753039 4.056463,1.287792 0.328119,1.533987 0.656236,3.067974 0.984354,4.601961 0.328611,-1.533987 0.656728,-3.067974 0.984846,-4.601961 0.114621,-0.534753 3.438107,-1.107381 4.055972,-1.287792 -0.617865,-0.18041 -3.941352,-0.753039 -4.055972,-1.287792 -0.328118,-1.533987 -0.656235,-3.067974 -0.984846,-4.601961",
    id: "path435-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 100.77965,45.255761 c -0.32762,1.533987 -0.65525,3.067974 -0.983859,4.601961 -0.114128,0.534753 -3.437614,1.107382 -4.055479,1.287792 0.617865,0.180411 3.941351,0.753039 4.055479,1.287792 0.328609,1.533987 0.656239,3.067974 0.983859,4.601961 0.32861,-1.533987 0.65722,-3.067974 0.98583,-4.601961 0.11413,-0.534753 3.43762,-1.107381 4.05548,-1.287792 -0.61786,-0.18041 -3.94135,-0.753039 -4.05548,-1.287792 -0.32861,-1.533987 -0.65722,-3.067974 -0.98583,-4.601961",
    id: "path437-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 114.89414,45.255761 c -0.32861,1.533987 -0.65723,3.067974 -0.98485,4.601961 -0.11412,0.534753 -3.43761,1.107382 -4.05646,1.287792 0.61885,0.180411 3.94234,0.753039 4.05646,1.287792 0.32762,1.533987 0.65624,3.067974 0.98485,4.601961 0.32861,-1.533987 0.65624,-3.067974 0.98485,-4.601961 0.11412,-0.534753 3.43761,-1.107381 4.05645,-1.287792 -0.61884,-0.18041 -3.94233,-0.753039 -4.05645,-1.287792 -0.32861,-1.533987 -0.65624,-3.067974 -0.98485,-4.601961",
    id: "path439-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 143.10835,61.727932 c -0.32762,1.533988 -0.65624,3.067974 -0.98485,4.601961 -0.11412,0.534753 -3.43761,1.107382 -4.05547,1.287792 0.61786,0.18041 3.94135,0.75304 4.05547,1.287791 0.32861,1.533988 0.65723,3.067975 0.98485,4.601963 0.32763,-1.533988 0.65624,-3.067975 0.98485,-4.601963 0.11413,-0.534751 3.43761,-1.10738 4.05548,-1.287791 -0.61787,-0.18041 -3.94135,-0.753039 -4.05548,-1.287792 -0.32861,-1.533987 -0.65722,-3.067973 -0.98485,-4.601961",
    id: "path441-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 143.12212,45.255761 c -0.3286,1.533987 -0.65623,3.067974 -0.98484,4.601961 -0.11413,0.534753 -3.43762,1.107382 -4.05548,1.287792 0.61786,0.180411 3.94135,0.753039 4.05548,1.287792 0.32861,1.533987 0.65624,3.067974 0.98484,4.601961 0.32763,-1.533987 0.65624,-3.067974 0.98485,-4.601961 0.11413,-0.534753 3.43762,-1.107381 4.05548,-1.287792 -0.61786,-0.18041 -3.94135,-0.753039 -4.05548,-1.287792 -0.32861,-1.533987 -0.65722,-3.067974 -0.98485,-4.601961",
    id: "path443-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 128.99485,61.727932 c -0.32861,1.533988 -0.65722,3.067974 -0.98485,4.601961 -0.11413,0.534753 -3.43761,1.107382 -4.05645,1.287792 0.61884,0.18041 3.94232,0.75304 4.05645,1.287791 0.32763,1.533988 0.65624,3.067975 0.98485,4.601963 0.32861,-1.533988 0.65624,-3.067975 0.98386,-4.601963 0.11511,-0.534751 3.4386,-1.10738 4.05646,-1.287791 -0.61786,-0.18041 -3.94135,-0.753039 -4.05646,-1.287792 -0.32762,-1.533987 -0.65525,-3.067973 -0.98386,-4.601961",
    id: "path445"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 129.00764,45.255761 c -0.32763,1.533987 -0.65624,3.067974 -0.98484,4.601961 -0.11413,0.534753 -3.43762,1.107382 -4.05548,1.287792 0.61786,0.180411 3.94135,0.753039 4.05548,1.287792 0.3286,1.533987 0.65721,3.067974 0.98484,4.601961 0.32861,-1.533987 0.65623,-3.067974 0.98485,-4.601961 0.11413,-0.534753 3.43762,-1.107381 4.05548,-1.287792 -0.61786,-0.18041 -3.94135,-0.753039 -4.05548,-1.287792 -0.32862,-1.533987 -0.65624,-3.067974 -0.98485,-4.601961",
    id: "path447"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 44.314331,144.22136 c -0.328118,1.53498 -0.656236,3.06797 -0.984354,4.60295 -0.114128,0.53426 -3.437614,1.10639 -4.055971,1.28779 0.618357,0.18042 3.941843,0.75255 4.055971,1.2878 0.328118,1.53298 0.656236,3.06797 0.984354,4.60196 0.32861,-1.53399 0.656728,-3.06898 0.984846,-4.60196 0.11462,-0.53525 3.438106,-1.10738 4.055971,-1.2878 -0.617865,-0.1814 -3.941351,-0.75353 -4.055971,-1.28779 -0.328118,-1.53498 -0.656236,-3.06797 -0.984846,-4.60295",
    id: "path449"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 44.341388,127.73822 c -0.328119,1.53398 -0.656237,3.06797 -0.984355,4.60196 -0.114127,0.53426 -3.437614,1.10639 -4.055971,1.28779 0.618356,0.18041 3.941844,0.75354 4.055971,1.2878 0.328118,1.53398 0.656236,3.06797 0.984355,4.60196 0.32861,-1.53399 0.656727,-3.06798 0.985337,-4.60196 0.114128,-0.53426 3.437614,-1.10739 4.05548,-1.2878 -0.617866,-0.1814 -3.941352,-0.75353 -4.05548,-1.28779 -0.32861,-1.53399 -0.656728,-3.06798 -0.985337,-4.60196",
    id: "path451"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 44.358113,111.2187 c -0.328118,1.53399 -0.656236,3.06847 -0.984354,4.60246 -0.11462,0.53426 -3.437614,1.10688 -4.055971,1.28779 0.618357,0.18042 3.941351,0.75304 4.055971,1.2878 0.328118,1.53398 0.656236,3.06797 0.984354,4.60196 0.32861,-1.53399 0.656728,-3.06798 0.985338,-4.60196 0.114128,-0.53476 3.437614,-1.10738 4.055479,-1.2878 -0.617865,-0.18091 -3.941351,-0.75353 -4.055479,-1.28779 -0.32861,-1.53399 -0.656728,-3.06847 -0.985338,-4.60246",
    id: "path453"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 44.324661,176.01147 c -0.328117,1.53399 -0.656235,3.06797 -0.984354,4.60296 -0.114128,0.53425 -3.438105,1.10638 -4.056463,1.28679 0.618358,0.18042 3.942335,0.75354 4.056463,1.28879 0.328119,1.53299 0.656237,3.06797 0.984354,4.60097 0.328119,-1.533 0.656236,-3.06798 0.984846,-4.60097 0.114129,-0.53525 3.437615,-1.10837 4.05548,-1.28879 -0.617865,-0.18041 -3.941351,-0.75254 -4.05548,-1.28679 -0.32861,-1.53499 -0.656727,-3.06897 -0.984846,-4.60296",
    id: "path455"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 44.324661,192.50357 c -0.328117,1.53399 -0.656235,3.06798 -0.984354,4.60196 -0.114128,0.53426 -3.438105,1.10738 -4.056463,1.2878 0.618358,0.18041 3.942335,0.75254 4.056463,1.28779 0.328119,1.53399 0.656237,3.06797 0.984354,4.60196 0.328119,-1.53399 0.656236,-3.06797 0.984846,-4.60196 0.114129,-0.53525 3.437615,-1.10738 4.05548,-1.28779 -0.617865,-0.18042 -3.941351,-0.75354 -4.05548,-1.2878 -0.32861,-1.53398 -0.656727,-3.06797 -0.984846,-4.60196",
    id: "path457"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 44.324661,208.99568 c -0.328117,1.53299 -0.656235,3.06798 -0.984354,4.60197 -0.114128,0.53424 -3.438105,1.10738 -4.056463,1.28679 0.618358,0.1814 3.942335,0.75353 4.056463,1.28779 0.328119,1.53498 0.656237,3.06798 0.984354,4.60295 0.328119,-1.53497 0.656236,-3.06797 0.984846,-4.60295 0.114129,-0.53426 3.437615,-1.10639 4.05548,-1.28779 -0.617865,-0.17941 -3.941351,-0.75255 -4.05548,-1.28679 -0.32861,-1.53399 -0.656727,-3.06898 -0.984846,-4.60197",
    id: "path459"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 44.324661,160.69751 c -0.328117,1.53499 -0.656235,3.06797 -0.984354,4.60296 -0.114128,0.53426 -3.438105,1.10638 -4.056463,1.28779 0.618358,0.17942 3.942335,0.75254 4.056463,1.2878 0.328119,1.53298 0.656237,3.06797 0.984354,4.60096 0.328119,-1.53299 0.656236,-3.06798 0.984846,-4.60096 0.114129,-0.53526 3.437615,-1.10738 4.05548,-1.2878 -0.617865,-0.18141 -3.941351,-0.75353 -4.05548,-1.28779 -0.32861,-1.53499 -0.656727,-3.06797 -0.984846,-4.60296",
    id: "path461"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 44.334992,94.727094 c -0.328117,1.533988 -0.656727,3.067975 -0.984846,4.601963 -0.114128,0.534751 -3.437614,1.107383 -4.055971,1.287793 0.618357,0.18041 3.941351,0.75354 4.055971,1.28779 0.328119,1.53399 0.656729,3.06797 0.984846,4.60196 0.328119,-1.53399 0.656236,-3.06797 0.984846,-4.60196 0.114129,-0.53425 3.437615,-1.10738 4.055972,-1.28779 -0.618357,-0.18041 -3.941844,-0.753042 -4.055972,-1.287793 -0.32861,-1.533988 -0.656727,-3.067975 -0.984846,-4.601963",
    id: "path463"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 44.324661,78.238976 c -0.328117,1.533987 -0.656235,3.068472 -0.984354,4.60246 -0.114128,0.534752 -3.438105,1.106883 -4.056463,1.287792 0.618358,0.180409 3.942335,0.753039 4.056463,1.287791 0.328119,1.533987 0.656237,3.067974 0.984354,4.601962 0.328119,-1.533988 0.656236,-3.067975 0.984846,-4.601962 0.114129,-0.534752 3.437615,-1.107381 4.05548,-1.287791 -0.617865,-0.180909 -3.941351,-0.75304 -4.05548,-1.287792 -0.32861,-1.533988 -0.656727,-3.068473 -0.984846,-4.60246",
    id: "path465"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 44.334992,61.743382 c -0.328117,1.534485 -0.656727,3.068472 -0.984846,4.602459 -0.114128,0.534254 -3.437614,1.106884 -4.055971,1.287792 0.618357,0.18041 3.941843,0.753039 4.055971,1.287791 0.328119,1.533988 0.656729,3.067975 0.984846,4.601962 0.328119,-1.533987 0.656236,-3.067974 0.984846,-4.601962 0.114129,-0.534752 3.437615,-1.10738 4.055972,-1.287791 -0.618357,-0.180908 -3.941844,-0.753538 -4.055972,-1.287792 -0.32861,-1.533987 -0.656727,-3.067975 -0.984846,-4.602459",
    id: "path467"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 44.324661,45.255761 c -0.328117,1.533987 -0.656235,3.067974 -0.984354,4.601961 -0.114128,0.534753 -3.438105,1.107382 -4.056463,1.287792 0.618358,0.180411 3.942335,0.753039 4.056463,1.287792 0.328119,1.533987 0.656237,3.067974 0.984354,4.601961 0.328119,-1.533987 0.656236,-3.067974 0.984846,-4.601961 0.114129,-0.534753 3.437615,-1.107381 4.05548,-1.287792 -0.617865,-0.18041 -3.941351,-0.753039 -4.05548,-1.287792 -0.32861,-1.533987 -0.656727,-3.067974 -0.984846,-4.601961",
    id: "path469"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 58.428325,144.22136 c -0.328118,1.53498 -0.656236,3.06797 -0.984354,4.60295 -0.11462,0.53426 -3.438106,1.10639 -4.056463,1.28779 0.618357,0.18042 3.941843,0.75255 4.056463,1.2878 0.328118,1.53298 0.656236,3.06797 0.984354,4.60196 0.328118,-1.53399 0.656236,-3.06898 0.984846,-4.60196 0.114128,-0.53525 3.438106,-1.10738 4.055972,-1.2878 -0.617866,-0.1814 -3.941844,-0.75353 -4.055972,-1.28779 -0.32861,-1.53498 -0.656728,-3.06797 -0.984846,-4.60295",
    id: "path471"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 58.455381,127.73822 c -0.328117,1.53398 -0.656236,3.06797 -0.984354,4.60196 -0.11462,0.53426 -3.437614,1.10639 -4.055972,1.28779 0.618358,0.18041 3.941352,0.75354 4.055972,1.2878 0.328118,1.53398 0.656237,3.06797 0.984354,4.60196 0.32861,-1.53399 0.656729,-3.06798 0.984846,-4.60196 0.11462,-0.53426 3.438107,-1.10739 4.055972,-1.2878 -0.617865,-0.1814 -3.941352,-0.75353 -4.055972,-1.28779 -0.328117,-1.53399 -0.656236,-3.06798 -0.984846,-4.60196",
    id: "path473"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 58.472107,111.2187 c -0.328118,1.53399 -0.656237,3.06847 -0.984354,4.60246 -0.11462,0.53426 -3.438107,1.10688 -4.056463,1.28779 0.618356,0.18042 3.941843,0.75304 4.056463,1.2878 0.328117,1.53398 0.656236,3.06797 0.984354,4.60196 0.328118,-1.53399 0.656728,-3.06798 0.984846,-4.60196 0.11462,-0.53476 3.437614,-1.10738 4.055972,-1.2878 -0.618358,-0.18091 -3.941352,-0.75353 -4.055972,-1.28779 -0.328118,-1.53399 -0.656728,-3.06847 -0.984846,-4.60246",
    id: "path475"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 58.438656,176.01147 c -0.328118,1.53399 -0.656728,3.06797 -0.984847,4.60296 -0.114128,0.53425 -3.437614,1.10638 -4.055972,1.28679 0.618358,0.18042 3.941353,0.75354 4.055972,1.28879 0.328119,1.53299 0.656729,3.06797 0.984847,4.60097 0.328117,-1.533 0.656236,-3.06798 0.984353,-4.60097 0.114621,-0.53525 3.438107,-1.10837 4.056465,-1.28879 -0.618358,-0.18041 -3.941844,-0.75254 -4.056465,-1.28679 -0.328117,-1.53499 -0.656236,-3.06897 -0.984353,-4.60296",
    id: "path477"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 58.438656,192.50357 c -0.328118,1.53399 -0.656728,3.06798 -0.984847,4.60196 -0.114128,0.53426 -3.437614,1.10738 -4.055972,1.2878 0.618358,0.18041 3.941844,0.75254 4.055972,1.28779 0.328119,1.53399 0.656729,3.06797 0.984847,4.60196 0.328117,-1.53399 0.656236,-3.06797 0.984353,-4.60196 0.114621,-0.53525 3.438107,-1.10738 4.056465,-1.28779 -0.618358,-0.18042 -3.941844,-0.75354 -4.056465,-1.2878 -0.328117,-1.53398 -0.656236,-3.06797 -0.984353,-4.60196",
    id: "path479"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 58.438656,208.99568 c -0.328118,1.53299 -0.656728,3.06798 -0.984847,4.60197 -0.114128,0.53424 -3.437614,1.10738 -4.055972,1.28679 0.618358,0.1814 3.941844,0.75353 4.055972,1.28779 0.328119,1.53498 0.656729,3.06798 0.984847,4.60295 0.328117,-1.53497 0.656236,-3.06797 0.984353,-4.60295 0.114621,-0.53426 3.438107,-1.10639 4.056465,-1.28779 -0.618358,-0.17941 -3.941844,-0.75255 -4.056465,-1.28679 -0.328117,-1.53399 -0.656236,-3.06898 -0.984353,-4.60197",
    id: "path481"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 58.438656,160.69751 c -0.328118,1.53499 -0.656728,3.06797 -0.984847,4.60296 -0.114128,0.53426 -3.437614,1.10638 -4.055972,1.28779 0.618358,0.18042 3.941844,0.75254 4.055972,1.2878 0.328119,1.53298 0.656729,3.06797 0.984847,4.60096 0.328117,-1.53299 0.656236,-3.06798 0.984353,-4.60096 0.114621,-0.53526 3.438107,-1.10838 4.056465,-1.2878 -0.618358,-0.18141 -3.941844,-0.75353 -4.056465,-1.28779 -0.328117,-1.53499 -0.656236,-3.06797 -0.984353,-4.60296",
    id: "path483"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 58.448494,94.727094 c -0.328117,1.533988 -0.656236,3.067975 -0.984354,4.601963 -0.114128,0.534751 -3.437614,1.107383 -4.055972,1.287793 0.618358,0.18041 3.941844,0.75354 4.055972,1.28779 0.328118,1.53399 0.656237,3.06797 0.984354,4.60196 0.32861,-1.53399 0.656729,-3.06797 0.984846,-4.60196 0.11462,-0.53425 3.438106,-1.10738 4.055972,-1.28779 -0.617866,-0.18041 -3.941352,-0.753042 -4.055972,-1.287793 -0.328117,-1.533988 -0.656236,-3.067975 -0.984846,-4.601963",
    id: "path485"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 58.438656,78.238976 c -0.328118,1.533987 -0.656728,3.068472 -0.984847,4.60246 -0.114128,0.534752 -3.437614,1.106883 -4.055972,1.287792 0.618358,0.180409 3.941844,0.753039 4.055972,1.287791 0.328119,1.533987 0.656729,3.067974 0.984847,4.601962 0.328117,-1.533988 0.656236,-3.067975 0.984353,-4.601962 0.114621,-0.534752 3.438107,-1.107381 4.056465,-1.287791 -0.618358,-0.180909 -3.941844,-0.75304 -4.056465,-1.287792 -0.328117,-1.533988 -0.656236,-3.068473 -0.984353,-4.60246",
    id: "path487"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 58.448494,61.743382 c -0.328117,1.534485 -0.656236,3.068472 -0.984354,4.602459 -0.114128,0.534254 -3.437614,1.106884 -4.055972,1.287792 0.618358,0.18041 3.941844,0.753039 4.055972,1.287791 0.328118,1.533988 0.656237,3.067975 0.984354,4.601962 0.32861,-1.533987 0.656729,-3.067974 0.984846,-4.601962 0.11462,-0.534752 3.438106,-1.10738 4.055972,-1.287791 -0.617866,-0.180908 -3.941352,-0.753538 -4.055972,-1.287792 -0.328117,-1.533987 -0.656236,-3.067975 -0.984846,-4.602459",
    id: "path489"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "#ff0000",
      strokeWidth: 0.0268082,
      strokeMiterlimit: 10
    },
    d: "m 58.438656,45.255761 c -0.328118,1.533987 -0.656728,3.067974 -0.984847,4.601961 -0.114128,0.534753 -3.437614,1.107382 -4.055972,1.287792 0.618358,0.180411 3.941844,0.753039 4.055972,1.287792 0.328119,1.533987 0.656729,3.067974 0.984847,4.601961 0.328117,-1.533987 0.656236,-3.067974 0.984353,-4.601961 0.114621,-0.534753 3.438107,-1.107381 4.056465,-1.287792 -0.618358,-0.18041 -3.941844,-0.753039 -4.056465,-1.287792 -0.328117,-1.533987 -0.656236,-3.067974 -0.984353,-4.601961",
    id: "path491"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#ff0000",
      strokeWidth: 1.28644881,
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    d: "m 17.861231,16.395074 c -2.370124,0 -1.512197,6.55159 -1.512197,7.860314 0,5.982948 0,11.965896 0,17.948845 0,19.785843 0,39.572183 0,59.358027 0,42.41588 0,84.83129 0,127.24668 0,5.27276 0,10.54553 0,15.81631 0,1.78815 -0.670993,5.5997 1.938701,5.5997 13.437096,0 26.873702,0 40.310798,0 36.67346,0 73.345937,0 110.018417,0 2.76858,0 2.22844,-2.99721 2.22844,-5.01761 0,-5.05049 0,-10.10098 0,-15.15248 0,-18.71285 0,-37.42769 0,-56.14153 0,-43.44005 0,-86.880591 0,-130.321133 0,-6.187779 0,-12.376554 0,-18.564833 0,-2.085185 0.47127,-4.815762 0,-6.865065 0,-3.039567 -8.52024,-1.767225 -10.19969,-1.767225 -8.03029,0 -16.05958,0 -24.08889,0 -38.63626,0 -77.273017,0 -115.909282,0 -0.928766,0 -1.857532,0 -2.786297,0",
    id: "path493"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRed2);
export default __webpack_public_path__ + "static/media/red2.23a20176fa3c8f0c9145b6c351ad06a0.svg";
export { ForwardRef as ReactComponent };